const translations = {
  'zh-TW': {
    headerTitle: '綜合命理',
    headerDesc: '四柱定局，鬼谷鉗命，袁氏稱骨，流年照歲。一念入盤，有問方解。',
    birthDateTime: '出生日期時間',
    year: '年份',
    month: '月份',
    day: '日期',
    hour: '時',
    minute: '分',
    selectYear: '選擇年份',
    selectMonth: '選擇月份',
    selectDay: '選擇日期',
    selectHour: '選擇時',
    selectMinute: '選擇分',
    gender: '性別',
    male: '男性',
    female: '女性',
    calculate: '立即測算',
    calculating: '計算中...',
    recalculate: '重新測算',
    reset: '重置',
    hideForm: '▲ 隱藏出生資料',
    showForm: '▼ 修改出生資料',
    validationError: '請填寫完整的出生日期時間',
    calcError: '計算失敗，請檢查輸入或稍後再試',
    footer: '© 2026 Seeable.Life',
    chatTitle: '💬 命理諮詢',
    chatCollapse: '▲ 收起',
    chatExpand: '▼ 展開',
    chatPlaceholder: '輸入您的問題...',
    chatSend: '發送',
    chatError: '抱歉，目前無法回答您的問題。請稍後再試。',
    q1: '我的日主旺衰如何？',
    q2: '我適合什麼職業？',
    q3: '何時適合結婚？',
    q4: '財運方面有什麼建議？',
    q5: '健康需要注意什麼？',
    resumeTitle: '淵海子平四柱八字',
    zodiac: '生肖',
    starSign: '星座',
    lifeExpect: '預期壽命',
    tabAi: '神明回答',
    tabOriginal: '原文典籍 Original',
    tabModern: '現代解釋 Modern',
    readingTabsLabel: '命盤閱讀模式',
    modernTitle: '現代解釋',
    modernDesc: '以下把典籍語句化成日常說法：先看命盤主氣，再看五行偏重、十神互動、大運節奏與鬼谷子象意。',
    modernCoreTitle: '命盤主氣',
    modernCoreCopy: '這個命盤以「{dayMaster}」為自己，月令落在「{month}」，整體旺衰判為「{strength}」。白話來說，這是看一個人天生用甚麼方式面對世界，以及哪種環境最容易牽動他的運勢。',
    modernFiveTitle: '五行與喜忌',
    modernFiveCopy: '五行中較明顯的是「{dominant}」，較不足的是「{missing}」。宜多借「{useful}」之氣，遇到「{caution}」則要放慢決定。',
    modernUsefulCopy: '喜用不是迷信式的保證，而是提示：在選擇方向、合作、人事與生活節奏時，優先靠近能補平命盤失衡的氣。',
    modernTenGodsTitle: '十神白話',
    modernTenGodsCopy: '十神可理解成人生中的角色力量：有人代表資源、有人代表壓力、有人代表表達、財務或人際。它們的位置不同，代表影響發生的場景不同。',
    modernLifeTitle: '性情與健康提示',
    modernLuckTitle: '大運節奏',
    modernLuckCopy: '大運不是單一年份的吉凶，而是十年一段的風向。每段干支像一股背景氣候，會放大或緩和命盤原本的傾向。',
    modernGuiguziTitle: '鬼谷子兩頭鉗白話',
    modernGuiguziCopy: '鬼谷子符頭落在「{symbol}」，本命對應「{match}」。白話來說，這段象意像人生底牌：看的是一生常見的困局、轉機與應事方式。',
    none: '無',
    timeline: '📈 人生運勢時間線',
    radarTitle: '🎯 六大運勢評分',
    score: '分',
    age: '歲',
    fortuneLabel: '人生運勢',
    fortuneScore: '運勢',
    event: '事件',
    health: '健康',
    wealth: '財運',
    career: '事業',
    marriage: '婚姻',
    children: '子女',
    social: '人際',
    baziTitle: '綜合命理',
    zipingTitle: '淵海子平四柱八字',
    zipingMethod: '日干為身，月令為勢。十神五行，定旺衰喜忌。',
    methodBasis: '取法依據',
    classicalText: '古文',
    plainText: '白話',
    dayMasterAndMonth: '日主與月令',
    monthCommand: '月令',
    strength: '旺衰',
    strengthScore: '旺衰分',
    dominantElement: '偏重五行',
    missingElements: '缺少五行',
    usefulElements: '喜用',
    cautionElements: '慎用',
    dayEmpty: '日空',
    element: '五行',
    hiddenStems: '藏元',
    tenGodsTitle: '明透十神',
    hiddenStemsTitle: '地支藏元',
    fiveElementsTitle: '五行旺衰',
    personalityHealthTitle: '性情與健康象意',
    liangtoujianTitle: '📜 鬼谷子兩頭鉗',
    liangtoujianMethod: '節氣排四柱，年時取符頭。一鉗落處，命格自現。',
    symbolHeads: '符頭',
    matchingKey: '命格對應',
    gua: '卦象',
    matchedReading: '本命詩文',
    star: '星曜',
    starCombinations: '星曜斷語',
    selectedLifeGate: '本命所落',
    yearPillar: '年柱',
    monthPillar: '月柱',
    dayPillar: '日柱',
    hourPillar: '時柱',
    dayMaster: '日主',
    guiguziTitle: '📜 鬼谷子兩頭鉗',
    judgement: '判斷',
    pattern: '格局',
    predictions: '各項預測',
    mingGongTitle: '鬼谷子算命術',
    mingGongCalc: '鬼谷子計算',
    luckPillars: '🔄 大運',
    startAge: '起運',
    direction: '方向',
    solar: '公曆',
    lunar: '農曆',
    mingGong: '鬼谷子',
    wealthLabel: '財富',
    descendants: '子嗣',
    achievement: '成就',
    careerLabel: '事業',
    detail: '詳解',
    matched: '本命對應',
    ganZhi: '干支',
    mingGe: '命格',
    explanation: '解釋',
    startLuck: '起運',
    prosperous: '運勢旺盛',
    caution: '需慎重',
    marriageLuck: '婚姻運',
    childrenLuck: '子女運',
    chengguTitle: '⚖️ 袁天罡稱骨算命',
    chengguMethod: '農曆年、月、日、時各取骨重。四數相合，再查稱骨歌。',
    boneWeight: '骨重',
    boneWeightBreakdown: '骨重明細',
    totalBoneWeight: '總骨重',
    boneSong: '稱骨歌',
    boneAnnotation: '註解',
    birthLunarDate: '農曆生辰',
    yearWeight: '年骨',
    monthWeight: '月骨',
    dayWeight: '日骨',
    hourWeight: '時骨',
    modernChengguTitle: '袁天罡稱骨白話',
    modernChengguCopy: '此命稱得「{weight}」，歌訣落在「{label}」。白話看，這是用生辰四項骨重合成一生命格，再與四柱、大運互相參照。',
    annualFortuneTitle: '流年運程',
    annualFortuneBrief: '流年以立春為歲首，取本命生肖與太歲相參。此處先看上一個、當前與下一個流年，一眼辨明宜進、宜守與需化解之處。',
    viewAnnualDetails: '查看流年運程詳解',
    annualPageTitle: '流年運程',
    annualPageDesc: '輸入公曆出生年月日時，即可起出本命生肖，並以前一年、今年與下一年太歲為三局，細看整體、家庭、財富、婚姻、事業、健康與十二流月起伏。',
    annualYearTabsLabel: '流年年份',
    previousLunarYear: '上一流年',
    currentLunarYear: '當前流年',
    nextLunarYear: '下一流年',
    taiSui: '流年太歲',
    relationship: '刑沖破害合',
    luckyStars: '吉星',
    unluckyStars: '兇星',
    overallFortune: '整體運程',
    annualOverallNarrativeTitle: '全年總論',
    categoryFortune: '五項運程',
    monthlyDevelopment: '逐月發展',
    specificDevelopment: '具體發展',
    monthFortuneChart: '流月運勢圖',
    monthlyScrollHint: '左右滑動查看十二個農曆流月。出生日期以公曆輸入，流月以農曆節令排列。',
    calendarBasis: '曆法標示',
    lunarCalendarLabel: '農曆流月',
    gregorianInputLabel: '公曆出生輸入',
    backToIntegrated: '返回綜合命理',
  },
  'zh-CN': {
    headerTitle: '综合命理',
    headerDesc: '四柱定局，鬼谷钳命，袁氏称骨，流年照岁。一念入盘，有问方解。',
    birthDateTime: '出生日期时间',
    year: '年份',
    month: '月份',
    day: '日期',
    hour: '时',
    minute: '分',
    selectYear: '选择年份',
    selectMonth: '选择月份',
    selectDay: '选择日期',
    selectHour: '选择时',
    selectMinute: '选择分',
    gender: '性别',
    male: '男性',
    female: '女性',
    calculate: '立即测算',
    calculating: '计算中...',
    recalculate: '重新测算',
    reset: '重置',
    hideForm: '▲ 隐藏出生资料',
    showForm: '▼ 修改出生资料',
    validationError: '请填写完整的出生日期时间',
    calcError: '计算失败，请检查输入或稍后再试',
    footer: '© 2026 Seeable.Life',
    chatTitle: '💬 命理咨询',
    chatCollapse: '▲ 收起',
    chatExpand: '▼ 展开',
    chatPlaceholder: '输入您的问题...',
    chatSend: '发送',
    chatError: '抱歉，目前无法回答您的问题。请稍后再试。',
    q1: '我的日主旺衰如何？',
    q2: '我适合什么职业？',
    q3: '何时适合结婚？',
    q4: '财运方面有什么建议？',
    q5: '健康需要注意什么？',
    resumeTitle: '渊海子平四柱八字',
    zodiac: '生肖',
    starSign: '星座',
    lifeExpect: '预期寿命',
    tabAi: '神明回答',
    tabOriginal: '原文典籍 Original',
    tabModern: '现代解释 Modern',
    readingTabsLabel: '命盘阅读模式',
    modernTitle: '现代解释',
    modernDesc: '以下把典籍语句化成日常说法：先看命盘主气，再看五行偏重、十神互动、大运节奏与鬼谷子象意。',
    modernCoreTitle: '命盘主气',
    modernCoreCopy: '这个命盘以“{dayMaster}”为自己，月令落在“{month}”，整体旺衰判为“{strength}”。白话来说，这是看一个人天生用什么方式面对世界，以及哪种环境最容易牵动他的运势。',
    modernFiveTitle: '五行与喜忌',
    modernFiveCopy: '五行中较明显的是“{dominant}”，较不足的是“{missing}”。宜多借“{useful}”之气，遇到“{caution}”则要放慢决定。',
    modernUsefulCopy: '喜用不是迷信式的保证，而是提示：在选择方向、合作、人事与生活节奏时，优先靠近能补平命盘失衡的气。',
    modernTenGodsTitle: '十神白话',
    modernTenGodsCopy: '十神可理解成人生中的角色力量：有人代表资源、有人代表压力、有人代表表达、财务或人际。它们的位置不同，代表影响发生的场景不同。',
    modernLifeTitle: '性情与健康提示',
    modernLuckTitle: '大运节奏',
    modernLuckCopy: '大运不是单一年份的吉凶，而是十年一段的风向。每段干支像一股背景气候，会放大或缓和命盘原本的倾向。',
    modernGuiguziTitle: '鬼谷子两头钳白话',
    modernGuiguziCopy: '鬼谷子符头落在“{symbol}”，本命对应“{match}”。白话来说，这段象意像人生底牌：看的是一生常见的困局、转机与应事方式。',
    none: '无',
    timeline: '📈 人生运势时间线',
    radarTitle: '🎯 六大运势评分',
    score: '分',
    age: '岁',
    fortuneLabel: '人生运势',
    fortuneScore: '运势',
    event: '事件',
    health: '健康',
    wealth: '财运',
    career: '事业',
    marriage: '婚姻',
    children: '子女',
    social: '人际',
    baziTitle: '综合命理',
    zipingTitle: '渊海子平四柱八字',
    zipingMethod: '日干为身，月令为势。十神五行，定旺衰喜忌。',
    methodBasis: '取法依据',
    classicalText: '古文',
    plainText: '白话',
    dayMasterAndMonth: '日主与月令',
    monthCommand: '月令',
    strength: '旺衰',
    strengthScore: '旺衰分',
    dominantElement: '偏重五行',
    missingElements: '缺少五行',
    usefulElements: '喜用',
    cautionElements: '慎用',
    dayEmpty: '日空',
    element: '五行',
    hiddenStems: '藏干',
    tenGodsTitle: '明干十神',
    hiddenStemsTitle: '地支藏干',
    fiveElementsTitle: '五行旺衰',
    personalityHealthTitle: '性情与健康象意',
    liangtoujianTitle: '📜 鬼谷子两头钳',
    liangtoujianMethod: '节气排四柱，年时取符头。一钳落处，命格自现。',
    symbolHeads: '符头',
    matchingKey: '命格对应',
    gua: '卦象',
    matchedReading: '本命诗文',
    star: '星曜',
    starCombinations: '星曜断语',
    selectedLifeGate: '本命所落',
    yearPillar: '年柱',
    monthPillar: '月柱',
    dayPillar: '日柱',
    hourPillar: '时柱',
    dayMaster: '日主',
    guiguziTitle: '📜 鬼谷子两头钳',
    judgement: '判断',
    pattern: '格局',
    predictions: '各项预测',
    mingGongTitle: '鬼谷子算命术',
    mingGongCalc: '鬼谷子计算',
    luckPillars: '🔄 大运',
    startAge: '起运',
    direction: '方向',
    solar: '公历',
    lunar: '农历',
    mingGong: '鬼谷子',
    wealthLabel: '财富',
    descendants: '子嗣',
    achievement: '成就',
    careerLabel: '事业',
    detail: '详解',
    matched: '本命对应',
    ganZhi: '干支',
    mingGe: '命格',
    explanation: '解释',
    startLuck: '起运',
    prosperous: '运势旺盛',
    caution: '需慎重',
    marriageLuck: '婚姻运',
    childrenLuck: '子女运',
    chengguTitle: '⚖️ 袁天罡称骨算命',
    chengguMethod: '农历年、月、日、时各取骨重。四数相合，再查称骨歌。',
    boneWeight: '骨重',
    boneWeightBreakdown: '骨重明细',
    totalBoneWeight: '总骨重',
    boneSong: '称骨歌',
    boneAnnotation: '注解',
    birthLunarDate: '农历生辰',
    yearWeight: '年骨',
    monthWeight: '月骨',
    dayWeight: '日骨',
    hourWeight: '时骨',
    modernChengguTitle: '袁天罡称骨白话',
    modernChengguCopy: '此命称得“{weight}”，歌诀落在“{label}”。白话看，这是用生辰四项骨重合成一生命格，再与四柱、大运互相参照。',
    annualFortuneTitle: '流年运程',
    annualFortuneBrief: '流年以立春为岁首，取本命生肖与太岁相参。此处先看上一个、当前与下一个流年，一眼辨明宜进、宜守与需化解之处。',
    viewAnnualDetails: '查看流年运程详解',
    annualPageTitle: '流年运程',
    annualPageDesc: '输入公历出生年月日时，即可起出本命生肖，并以前一年、今年与下一年太岁为三局，细看整体、家庭、财富、婚姻、事业、健康与十二流月起伏。',
    annualYearTabsLabel: '流年年份',
    previousLunarYear: '上一流年',
    currentLunarYear: '当前流年',
    nextLunarYear: '下一流年',
    taiSui: '流年太岁',
    relationship: '刑冲破害合',
    luckyStars: '吉星',
    unluckyStars: '凶星',
    overallFortune: '整体运程',
    annualOverallNarrativeTitle: '全年总论',
    categoryFortune: '五项运程',
    monthlyDevelopment: '逐月发展',
    specificDevelopment: '具体发展',
    monthFortuneChart: '流月运势图',
    monthlyScrollHint: '左右滑动查看十二个农历流月。出生日期以公历输入，流月以农历节令排列。',
    calendarBasis: '历法标示',
    lunarCalendarLabel: '农历流月',
    gregorianInputLabel: '公历出生输入',
    backToIntegrated: '返回综合命理',
  },
  'en': {
    headerTitle: 'Integrated Destiny',
    headerDesc: 'Four pillars, Guiguzi, bone-weight destiny and annual fortune cycles are calculated first. The divine answer opens after your question.',
    birthDateTime: 'Date & Time of Birth',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    selectYear: 'Select year',
    selectMonth: 'Select month',
    selectDay: 'Select day',
    selectHour: 'Select hour',
    selectMinute: 'Select minute',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    calculate: 'Find my reading',
    calculating: 'Calculating...',
    recalculate: 'Calculate again',
    reset: 'Reset',
    hideForm: '▲ Hide birth data',
    showForm: '▼ Edit birth data',
    validationError: 'Please fill in all birth date and time fields',
    calcError: 'Calculation failed. Please check input or try again later',
    footer: '© 2026 Seeable.Life',
    chatTitle: '💬 Destiny Consultation',
    chatCollapse: '▲ Collapse',
    chatExpand: '▼ Expand',
    chatPlaceholder: 'Ask a question...',
    chatSend: 'Send',
    chatError: 'Sorry, unable to answer right now. Please try again later.',
    q1: 'How strong is my day master?',
    q2: 'What career suits me?',
    q3: 'When is a good time to marry?',
    q4: 'Any advice on wealth?',
    q5: 'What health issues to watch?',
    resumeTitle: 'Yuanhai Ziping Bazi',
    zodiac: 'Zodiac',
    starSign: 'Star Sign',
    lifeExpect: 'Life Expectancy',
    tabAi: 'Divine Answer',
    tabOriginal: 'Original 原文典籍',
    tabModern: 'Modern 現代解釋',
    readingTabsLabel: 'Chart reading mode',
    modernTitle: 'Modern Explanation',
    modernDesc: 'This tab turns the classical chart into plain language: core temperament, five-element balance, ten-god roles, luck-cycle rhythm and Guiguzi imagery.',
    modernCoreTitle: 'Core chart energy',
    modernCoreCopy: 'This chart uses “{dayMaster}” as the self. The month command is “{month}”, and the overall strength is “{strength}”. In plain terms, this describes the native way of meeting the world and the environments that most affect the person’s fortune.',
    modernFiveTitle: 'Five elements and useful/caution signs',
    modernFiveCopy: 'The most visible element is “{dominant}”; the lighter or missing side is “{missing}”. The chart benefits from “{useful}”, while “{caution}” calls for slower decisions.',
    modernUsefulCopy: 'Useful elements are not a guarantee. They are a practical hint: when choosing direction, partners, timing or daily rhythm, lean toward what balances the chart.',
    modernTenGodsTitle: 'Ten gods in plain language',
    modernTenGodsCopy: 'The ten gods are role forces in life: resources, pressure, expression, wealth, relationships and peers. Their pillar positions show where those forces tend to appear.',
    modernLifeTitle: 'Temperament and health hints',
    modernLuckTitle: 'Luck-cycle rhythm',
    modernLuckCopy: 'Luck pillars are not one-year verdicts. Each ten-year pillar is like background weather, amplifying or softening the original chart pattern.',
    modernGuiguziTitle: 'Guiguzi Liangtoujian in plain language',
    modernGuiguziCopy: 'The Guiguzi key is “{symbol}”, matching “{match}”. In plain terms, this is the life-image card: recurring challenges, turning points and the way events tend to answer the person.',
    none: 'None',
    timeline: '📈 Life Fortune Timeline',
    radarTitle: '🎯 Six Fortune Scores',
    score: 'pts',
    age: 'yrs',
    fortuneLabel: 'Life Fortune',
    fortuneScore: 'Fortune',
    event: 'Event',
    health: 'Health',
    wealth: 'Wealth',
    career: 'Career',
    marriage: 'Marriage',
    children: 'Children',
    social: 'Social',
    baziTitle: 'Integrated Destiny',
    zipingTitle: 'Yuanhai Ziping Bazi',
    zipingMethod: 'Use the day stem as the self, then read the year, month command, hour, ten gods, hidden stems, five-element strength and useful elements.',
    methodBasis: 'Method',
    classicalText: 'Classical',
    plainText: 'Plain',
    dayMasterAndMonth: 'Day master and month',
    monthCommand: 'Month command',
    strength: 'Strength',
    strengthScore: 'Strength score',
    dominantElement: 'Dominant element',
    missingElements: 'Missing elements',
    usefulElements: 'Useful',
    cautionElements: 'Caution',
    dayEmpty: 'Empty branches',
    element: 'Element',
    hiddenStems: 'Hidden stems',
    tenGodsTitle: 'Visible ten gods',
    hiddenStemsTitle: 'Hidden stems',
    fiveElementsTitle: 'Five-element balance',
    personalityHealthTitle: 'Temperament and health symbolism',
    liangtoujianTitle: '📜 Guiguzi Liangtoujian',
    liangtoujianMethod: 'The four pillars are calculated by solar terms. The year and hour stems form the key; the hour stem plus year branch selects the reading.',
    symbolHeads: 'Key',
    matchingKey: 'Matched sign',
    gua: 'Hexagram',
    matchedReading: 'Your classical reading',
    star: 'Star',
    starCombinations: 'Star readings',
    selectedLifeGate: 'Matched life gate',
    yearPillar: 'Year Pillar',
    monthPillar: 'Month Pillar',
    dayPillar: 'Day Pillar',
    hourPillar: 'Hour Pillar',
    dayMaster: 'Day Master',
    guiguziTitle: '📜 Guiguzi Liangtoujian',
    judgement: 'Judgement',
    pattern: 'Pattern',
    predictions: 'Predictions',
    mingGongTitle: 'Guiguzi calculation',
    mingGongCalc: 'Guiguzi calculation',
    luckPillars: '🔄 Luck Pillars',
    startAge: 'Start Age',
    direction: 'Direction',
    solar: 'Solar',
    lunar: 'Lunar',
    mingGong: 'Guiguzi',
    wealthLabel: 'Wealth',
    descendants: 'Descendants',
    achievement: 'Achievement',
    careerLabel: 'Career',
    detail: 'Details',
    matched: 'Matched',
    ganZhi: 'Stem-Branch',
    mingGe: 'Destiny Type',
    explanation: 'Explanation',
    startLuck: 'Start Luck',
    prosperous: 'Prosperous',
    caution: 'Caution needed',
    marriageLuck: 'Marriage luck',
    childrenLuck: 'Children luck',
    chengguTitle: '⚖️ Yuan Tiangang Bone-Weight',
    chengguMethod: 'The lunar birth year, month, day and hour each carry a weight. The total is matched to the bone-weight verse.',
    boneWeight: 'Bone weight',
    boneWeightBreakdown: 'Weight breakdown',
    totalBoneWeight: 'Total weight',
    boneSong: 'Bone-weight verse',
    boneAnnotation: 'Commentary',
    birthLunarDate: 'Lunar birth date',
    yearWeight: 'Year weight',
    monthWeight: 'Month weight',
    dayWeight: 'Day weight',
    hourWeight: 'Hour weight',
    modernChengguTitle: 'Yuan Tiangang in plain language',
    modernChengguCopy: 'This chart weighs “{weight}”, matching “{label}”. In plain terms, the four birth weights form a life pattern, then the Bazi chart and luck cycles refine the reading.',
    annualFortuneTitle: 'Annual fortune',
    annualFortuneBrief: 'Annual fortune uses Li Chun as the year boundary, comparing your birth zodiac branch with the year’s Tai Sui branch. This summary shows previous, current and next lunar-year fortune.',
    viewAnnualDetails: 'View annual fortune details',
    annualPageTitle: 'Annual fortune',
    annualPageDesc: 'Enter a Gregorian birth date and time to reveal the birth zodiac, then read the previous, current and next Tai Sui years across overall fortune, five life areas and twelve lunar months.',
    annualYearTabsLabel: 'Annual fortune years',
    previousLunarYear: 'Previous year',
    currentLunarYear: 'Current year',
    nextLunarYear: 'Next year',
    taiSui: 'Tai Sui year',
    relationship: 'Relationship',
    luckyStars: 'Lucky stars',
    unluckyStars: 'Unlucky stars',
    overallFortune: 'Overall fortune',
    annualOverallNarrativeTitle: 'Year reading',
    categoryFortune: 'Five-area fortune',
    monthlyDevelopment: 'Monthly development',
    specificDevelopment: 'Specific development',
    monthFortuneChart: 'Monthly fortune chart',
    monthlyScrollHint: 'Scroll horizontally to see all twelve lunar months. Birth details are entered in the Gregorian calendar, while the monthly cards follow lunar-solar month order.',
    calendarBasis: 'Calendar basis',
    lunarCalendarLabel: 'Lunar month',
    gregorianInputLabel: 'Gregorian birth input',
    backToIntegrated: 'Back to Integrated Destiny',
  }
};

Object.assign(translations, {
  ko: {
    ...translations.en,
    headerTitle: '종합 명리',
    headerDesc: '사주, 귀곡자, 칭골, 해마다의 운세를 먼저 세워 길흉의 흐름을 봅니다.',
    birthDateTime: '출생 날짜와 시간',
    year: '년',
    month: '월',
    day: '일',
    hour: '시',
    minute: '분',
    selectYear: '연도 선택',
    selectMonth: '월 선택',
    selectDay: '일 선택',
    selectHour: '시 선택',
    selectMinute: '분 선택',
    gender: '성별',
    male: '남성',
    female: '여성',
    calculate: '운세 보기',
    calculating: '계산 중...',
    recalculate: '다시 계산',
    reset: '초기화',
    hideForm: '▲ 출생 정보 숨기기',
    showForm: '▼ 출생 정보 수정',
    validationError: '출생 날짜와 시간을 모두 입력해 주세요',
    calcError: '계산에 실패했습니다. 입력값을 확인하거나 잠시 후 다시 시도해 주세요',
    chatTitle: '💬 명리 상담',
    chatPlaceholder: '궁금한 일을 물어보세요...',
    chatSend: '보내기',
    chatError: '현재 답변할 수 없습니다. 잠시 후 다시 시도해 주세요.',
    q1: '나의 일간은 강한가요?',
    q2: '어떤 직업이 맞나요?',
    q3: '결혼운은 언제 좋은가요?',
    q4: '재물운 조언은 무엇인가요?',
    q5: '건강에서 조심할 점은?',
    resumeTitle: '연해자평 사주팔자',
    tabAi: '추가 문답',
    tabOriginal: '원문 Original',
    tabModern: '현대 풀이 Modern',
    readingTabsLabel: '명반 읽기 방식',
    modernTitle: '현대 풀이',
    modernDesc: '고전 문장을 일상 언어로 풀어, 핵심 기운·오행 균형·십신·대운·귀곡자 상의를 순서대로 봅니다.',
    modernCoreTitle: '명반의 중심 기운',
    modernCoreCopy: '이 명반은 “{dayMaster}”를 자신으로 삼고, 월령은 “{month}”, 전체 강약은 “{strength}”입니다. 쉽게 말해 세상을 대하는 타고난 방식과 운을 크게 흔드는 환경을 보는 것입니다.',
    modernFiveTitle: '오행과 희기',
    modernFiveCopy: '두드러진 오행은 “{dominant}”, 부족한 쪽은 “{missing}”입니다. “{useful}”의 기운은 보탬이 되고, “{caution}”을 만날 때는 결정을 늦추는 편이 좋습니다.',
    modernUsefulCopy: '희용은 보장이 아니라 균형의 힌트입니다. 방향, 협력자, 시기, 생활 리듬을 고를 때 명반의 치우침을 보완하는 쪽을 우선합니다.',
    modernTenGodsTitle: '십신 쉬운 풀이',
    modernTenGodsCopy: '십신은 인생의 역할 힘입니다. 자원, 압력, 표현, 재물, 관계, 동료 같은 기운이 어느 자리에서 나타나는지 봅니다.',
    modernLifeTitle: '성정과 건강 힌트',
    modernLuckTitle: '대운의 흐름',
    modernLuckCopy: '대운은 한 해의 판결이 아니라 십 년 단위의 배경 기후입니다. 각 간지는 원래 명반의 경향을 키우거나 누그러뜨립니다.',
    modernGuiguziTitle: '귀곡자 양두겸 쉬운 풀이',
    modernGuiguziCopy: '귀곡자 부두는 “{symbol}”, 본명 대응은 “{match}”입니다. 쉽게 말해 반복되는 난관, 전환점, 일이 응하는 방식을 보여주는 인생의 상징 카드입니다.',
    none: '없음',
    baziTitle: '종합 명리',
    zipingTitle: '연해자평 사주팔자',
    zipingMethod: '일간을 중심으로 월령, 십신, 장간, 오행의 왕쇠와 희기를 살핍니다.',
    methodBasis: '법식',
    classicalText: '고문',
    plainText: '쉬운 풀이',
    dayMasterAndMonth: '일간과 월령',
    monthCommand: '월령',
    strength: '왕쇠',
    strengthScore: '왕쇠 점수',
    dominantElement: '강한 오행',
    missingElements: '부족한 오행',
    usefulElements: '기운을 돕는 오행',
    cautionElements: '조심할 오행',
    dayEmpty: '공망',
    element: '오행',
    hiddenStems: '장간',
    tenGodsTitle: '천간 십신',
    hiddenStemsTitle: '지지 장간',
    fiveElementsTitle: '오행 균형',
    personalityHealthTitle: '성정과 건강 징조',
    liangtoujianTitle: '📜 귀곡자 양두겸',
    liangtoujianMethod: '절기로 사주를 세운 뒤 년간과 시간으로 부두를 삼아 명격을 찾습니다.',
    symbolHeads: '부두',
    matchingKey: '대응 명격',
    gua: '괘상',
    matchedReading: '본명 시문',
    star: '성요',
    starCombinations: '성요 단어',
    selectedLifeGate: '본명 위치',
    yearPillar: '년주',
    monthPillar: '월주',
    dayPillar: '일주',
    hourPillar: '시주',
    dayMaster: '일간',
    guiguziTitle: '📜 귀곡자 양두겸',
    judgement: '판단',
    pattern: '격국',
    predictions: '예측',
    luckPillars: '🔄 대운',
    startAge: '시작 나이',
    direction: '방향',
    solar: '양력',
    lunar: '음력',
    wealthLabel: '재물',
    descendants: '자손',
    achievement: '성취',
    careerLabel: '직업',
    detail: '상세',
    matched: '본명 대응',
    ganZhi: '간지',
    mingGe: '명격',
    explanation: '풀이',
    startLuck: '기운 시작',
    prosperous: '운세가 왕성함',
    caution: '신중함 필요',
    marriageLuck: '혼인운',
    childrenLuck: '자녀운',
    chengguTitle: '⚖️ 원천강 칭골산명',
    chengguMethod: '음력 생년, 생월, 생일, 생시에 각각 골중을 붙이고 합산해 칭골가를 봅니다.',
    boneWeight: '골중',
    boneWeightBreakdown: '골중 세부',
    totalBoneWeight: '총 골중',
    boneSong: '칭골가',
    boneAnnotation: '주해',
    birthLunarDate: '음력 생신',
    yearWeight: '년 골중',
    monthWeight: '월 골중',
    dayWeight: '일 골중',
    hourWeight: '시 골중',
    modernChengguTitle: '원천강 칭골 쉬운 풀이',
    modernChengguCopy: '이 명은 “{weight}”로, “{label}”에 해당합니다. 쉽게 말해 네 가지 생신 무게가 인생의 밑그림을 만들고, 사주와 대운이 그 흐름을 더 자세히 보여줍니다.',
  },
  ja: {
    ...translations.en,
    headerTitle: '総合命理',
    headerDesc: '四柱、鬼谷子、称骨、流年を先に立て、吉凶の流れを読みます。',
    birthDateTime: '出生日時',
    year: '年',
    month: '月',
    day: '日',
    hour: '時',
    minute: '分',
    selectYear: '年を選択',
    selectMonth: '月を選択',
    selectDay: '日を選択',
    selectHour: '時を選択',
    selectMinute: '分を選択',
    gender: '性別',
    male: '男性',
    female: '女性',
    calculate: '占う',
    calculating: '算出中...',
    recalculate: 'もう一度算出',
    reset: 'リセット',
    hideForm: '▲ 出生情報を隠す',
    showForm: '▼ 出生情報を修正',
    validationError: '出生日時をすべて入力してください',
    calcError: '算出に失敗しました。入力を確認して再度お試しください',
    chatTitle: '💬 命理相談',
    chatPlaceholder: '問いを入力してください...',
    chatSend: '送信',
    chatError: '現在回答できません。しばらくしてから再度お試しください。',
    q1: '日主の強弱は？',
    q2: '向いている仕事は？',
    q3: '結婚に良い時期は？',
    q4: '財運の助言は？',
    q5: '健康で注意すべきことは？',
    resumeTitle: '淵海子平 四柱推命',
    tabAi: '追加問答',
    tabOriginal: '原文 Original',
    tabModern: '現代解釈 Modern',
    readingTabsLabel: '命盤の読み方',
    modernTitle: '現代解釈',
    modernDesc: '古典文を日常語に置き換え、中心の気・五行バランス・十神・大運・鬼谷子の象意を順に読みます。',
    modernCoreTitle: '命盤の中心の気',
    modernCoreCopy: 'この命盤は「{dayMaster}」を自分自身とし、月令は「{month}」、全体の強弱は「{strength}」です。平たく言えば、生まれ持った世界への向き合い方と、運勢を動かしやすい環境を見るものです。',
    modernFiveTitle: '五行と喜忌',
    modernFiveCopy: '目立つ五行は「{dominant}」、不足気味なのは「{missing}」。 「{useful}」の気を借りると整いやすく、「{caution}」が強い時は判断を急がないことです。',
    modernUsefulCopy: '喜用は絶対の保証ではなく、均衡の手がかりです。方向、相手、時期、生活リズムを選ぶ時、命盤の偏りを補うものを優先します。',
    modernTenGodsTitle: '十神の平易な読み',
    modernTenGodsCopy: '十神は人生に現れる役割の力です。資源、圧力、表現、財、関係、仲間などが、どの柱に出るかで場面が変わります。',
    modernLifeTitle: '性情と健康の手がかり',
    modernLuckTitle: '大運の流れ',
    modernLuckCopy: '大運は一年単位の断定ではなく、十年ごとの背景気候です。各干支が命盤本来の傾向を強めたり和らげたりします。',
    modernGuiguziTitle: '鬼谷子両頭鉗の平易な読み',
    modernGuiguziCopy: '鬼谷子の符頭は「{symbol}」、本命対応は「{match}」。平たく言えば、繰り返し現れる課題、転機、物事の応じ方を示す人生の象徴札です。',
    none: 'なし',
    baziTitle: '総合命理',
    zipingTitle: '淵海子平 四柱推命',
    zipingMethod: '日干を主とし、月令・十神・蔵干・五行の旺衰と喜忌を読みます。',
    methodBasis: '法式',
    classicalText: '古文',
    plainText: '平易な解釈',
    dayMasterAndMonth: '日主と月令',
    monthCommand: '月令',
    strength: '旺衰',
    strengthScore: '旺衰点',
    dominantElement: '強い五行',
    missingElements: '不足する五行',
    usefulElements: '喜用',
    cautionElements: '慎む五行',
    dayEmpty: '空亡',
    element: '五行',
    hiddenStems: '蔵干',
    tenGodsTitle: '天干十神',
    hiddenStemsTitle: '地支蔵干',
    fiveElementsTitle: '五行の均衡',
    personalityHealthTitle: '性情と健康の象意',
    liangtoujianTitle: '📜 鬼谷子両頭鉗',
    liangtoujianMethod: '節気で四柱を立て、年干と時干を符頭として命格を求めます。',
    symbolHeads: '符頭',
    matchingKey: '命格対応',
    gua: '卦象',
    matchedReading: '本命詩文',
    star: '星曜',
    starCombinations: '星曜断語',
    selectedLifeGate: '本命の位置',
    yearPillar: '年柱',
    monthPillar: '月柱',
    dayPillar: '日柱',
    hourPillar: '時柱',
    dayMaster: '日主',
    guiguziTitle: '📜 鬼谷子両頭鉗',
    judgement: '判断',
    pattern: '格局',
    predictions: '予測',
    luckPillars: '🔄 大運',
    startAge: '起運',
    direction: '方向',
    solar: '西暦',
    lunar: '旧暦',
    wealthLabel: '財',
    descendants: '子孫',
    achievement: '成就',
    careerLabel: '仕事',
    detail: '詳解',
    matched: '本命対応',
    ganZhi: '干支',
    mingGe: '命格',
    explanation: '解釈',
    startLuck: '起運',
    prosperous: '運気旺盛',
    caution: '慎重を要す',
    marriageLuck: '婚姻運',
    childrenLuck: '子女運',
    chengguTitle: '⚖️ 袁天罡称骨',
    chengguMethod: '旧暦の年、月、日、時にそれぞれ骨重を当て、合計して称骨歌を読みます。',
    boneWeight: '骨重',
    boneWeightBreakdown: '骨重内訳',
    totalBoneWeight: '総骨重',
    boneSong: '称骨歌',
    boneAnnotation: '注解',
    birthLunarDate: '旧暦出生',
    yearWeight: '年骨',
    monthWeight: '月骨',
    dayWeight: '日骨',
    hourWeight: '時骨',
    modernChengguTitle: '袁天罡称骨の平易な読み',
    modernChengguCopy: 'この命は「{weight}」で、「{label}」に当たります。平たく言えば、出生四項の骨重が人生の型を作り、四柱と大運がその流れを細かく照らします。',
  },
  ms: {
    ...translations.en,
    headerTitle: 'Metafizik Bersepadu',
    headerDesc: 'Bazi, Guiguzi, timbang tulang dan nasib tahunan dikira dahulu untuk membaca aliran baik buruk.',
    birthDateTime: 'Tarikh & masa lahir',
    year: 'Tahun',
    month: 'Bulan',
    day: 'Hari',
    hour: 'Jam',
    minute: 'Minit',
    selectYear: 'Pilih tahun',
    selectMonth: 'Pilih bulan',
    selectDay: 'Pilih hari',
    selectHour: 'Pilih jam',
    selectMinute: 'Pilih minit',
    gender: 'Jantina',
    male: 'Lelaki',
    female: 'Perempuan',
    calculate: 'Buka bacaan',
    calculating: 'Mengira...',
    recalculate: 'Kira semula',
    reset: 'Tetap semula',
    hideForm: '▲ Sembunyi butiran lahir',
    showForm: '▼ Ubah butiran lahir',
    validationError: 'Sila lengkapkan tarikh dan masa lahir',
    calcError: 'Pengiraan gagal. Semak input atau cuba lagi nanti',
    chatTitle: '💬 Tanya nasib',
    chatPlaceholder: 'Tulis soalan anda...',
    chatSend: 'Hantar',
    chatError: 'Maaf, belum dapat menjawab sekarang. Cuba lagi nanti.',
    q1: 'Sejauh mana kuat day master saya?',
    q2: 'Kerjaya apa yang sesuai?',
    q3: 'Bilakah masa baik untuk berkahwin?',
    q4: 'Nasihat untuk rezeki?',
    q5: 'Apa yang perlu dijaga untuk kesihatan?',
    resumeTitle: 'Yuanhai Ziping Bazi',
    tabAi: 'Soal jawab',
    tabOriginal: 'Original Teks klasik',
    tabModern: 'Modern Tafsiran',
    readingTabsLabel: 'Mod bacaan carta',
    modernTitle: 'Tafsiran moden',
    modernDesc: 'Bahagian ini menukar bahasa klasik kepada bahasa harian: tenaga asas, imbangan lima unsur, peranan ten gods, rentak nasib dan bayang Guiguzi.',
    modernCoreTitle: 'Tenaga utama carta',
    modernCoreCopy: 'Carta ini membaca “{dayMaster}” sebagai diri. Arahan bulan ialah “{month}”, dan kekuatan keseluruhan ialah “{strength}”. Mudahnya, ia menunjukkan cara semula jadi seseorang menghadapi dunia dan suasana yang paling menggerakkan nasibnya.',
    modernFiveTitle: 'Lima unsur dan tanda baik/berhati-hati',
    modernFiveCopy: 'Unsur yang paling ketara ialah “{dominant}”; sisi yang kurang ialah “{missing}”. Carta lebih terbantu oleh “{useful}”, manakala “{caution}” meminta keputusan dibuat lebih perlahan.',
    modernUsefulCopy: 'Unsur berguna bukan jaminan mutlak. Ia petunjuk keseimbangan: pilih arah, rakan, masa dan rentak hidup yang membantu menstabilkan carta.',
    modernTenGodsTitle: 'Ten gods dalam bahasa mudah',
    modernTenGodsCopy: 'Ten gods ialah kuasa peranan dalam hidup: sumber, tekanan, ekspresi, rezeki, hubungan dan rakan sebaya. Kedudukan tiang menunjukkan di mana kuasa itu muncul.',
    modernLifeTitle: 'Watak dan petanda kesihatan',
    modernLuckTitle: 'Rentak tiang nasib',
    modernLuckCopy: 'Tiang nasib bukan hukum satu tahun. Setiap tiang sepuluh tahun seperti cuaca latar yang menguatkan atau melembutkan pola asal carta.',
    modernGuiguziTitle: 'Guiguzi Liangtoujian dalam bahasa mudah',
    modernGuiguziCopy: 'Kunci Guiguzi ialah “{symbol}”, sepadan dengan “{match}”. Mudahnya, ia seperti kad bayang hidup: cabaran berulang, titik perubahan dan cara peristiwa menjawab diri seseorang.',
    none: 'Tiada',
    baziTitle: 'Metafizik Bersepadu',
    zipingTitle: 'Yuanhai Ziping Bazi',
    zipingMethod: 'Day stem dibaca sebagai diri, bersama arahan bulan, ten gods, hidden stems, keseimbangan lima unsur dan unsur berguna.',
    methodBasis: 'Kaedah',
    classicalText: 'Klasik',
    plainText: 'Bahasa mudah',
    dayMasterAndMonth: 'Day master dan bulan',
    monthCommand: 'Arahan bulan',
    strength: 'Kekuatan',
    strengthScore: 'Skor kekuatan',
    dominantElement: 'Unsur dominan',
    missingElements: 'Unsur kurang',
    usefulElements: 'Unsur membantu',
    cautionElements: 'Unsur perlu dijaga',
    dayEmpty: 'Cabang kosong',
    element: 'Unsur',
    hiddenStems: 'Hidden stems',
    tenGodsTitle: 'Ten gods zahir',
    hiddenStemsTitle: 'Hidden stems',
    fiveElementsTitle: 'Imbangan lima unsur',
    personalityHealthTitle: 'Watak dan petanda kesihatan',
    liangtoujianTitle: '📜 Guiguzi Liangtoujian',
    liangtoujianMethod: 'Empat tiang dikira mengikut solar terms; stem tahun dan stem jam menjadi kunci bacaan.',
    symbolHeads: 'Kunci',
    matchingKey: 'Padanan nasib',
    gua: 'Gua',
    matchedReading: 'Bacaan klasik anda',
    star: 'Bintang',
    starCombinations: 'Bacaan bintang',
    selectedLifeGate: 'Gerbang nasib sepadan',
    yearPillar: 'Tiang tahun',
    monthPillar: 'Tiang bulan',
    dayPillar: 'Tiang hari',
    hourPillar: 'Tiang jam',
    dayMaster: 'Day master',
    guiguziTitle: '📜 Guiguzi Liangtoujian',
    judgement: 'Hukum',
    pattern: 'Pola',
    predictions: 'Ramalan',
    luckPillars: '🔄 Tiang nasib',
    startAge: 'Umur mula',
    direction: 'Arah',
    solar: 'Solar',
    lunar: 'Lunar',
    wealthLabel: 'Rezeki',
    descendants: 'Zuriat',
    achievement: 'Pencapaian',
    careerLabel: 'Kerjaya',
    detail: 'Butiran',
    matched: 'Padanan',
    ganZhi: 'Stem-Branch',
    mingGe: 'Jenis nasib',
    explanation: 'Penjelasan',
    startLuck: 'Mula nasib',
    prosperous: 'Nasib kuat',
    caution: 'Perlu berhati-hati',
    marriageLuck: 'Nasib perkahwinan',
    childrenLuck: 'Nasib anak',
    chengguTitle: '⚖️ Timbang Tulang Yuan Tiangang',
    chengguMethod: 'Tahun, bulan, hari dan jam lahir lunar masing-masing diberi berat, lalu jumlahnya dipadankan dengan syair timbang tulang.',
    boneWeight: 'Berat tulang',
    boneWeightBreakdown: 'Pecahan berat',
    totalBoneWeight: 'Jumlah berat',
    boneSong: 'Syair timbang tulang',
    boneAnnotation: 'Huraian',
    birthLunarDate: 'Tarikh lahir lunar',
    yearWeight: 'Berat tahun',
    monthWeight: 'Berat bulan',
    dayWeight: 'Berat hari',
    hourWeight: 'Berat jam',
    modernChengguTitle: 'Yuan Tiangang dalam bahasa mudah',
    modernChengguCopy: 'Bacaan ini menimbang “{weight}”, sepadan dengan “{label}”. Dalam bahasa mudah, empat berat lahir membentuk pola hidup, kemudian carta Bazi dan kitaran nasib memperincikannya.',
  },
  es: {
    ...translations.en,
    headerTitle: 'Destino integrado',
    headerDesc: 'Bazi, Guiguzi, peso óseo y fortuna anual se calculan primero para leer el flujo de fortuna.',
    birthDateTime: 'Fecha y hora de nacimiento',
    year: 'Año',
    month: 'Mes',
    day: 'Día',
    hour: 'Hora',
    minute: 'Minuto',
    selectYear: 'Elegir año',
    selectMonth: 'Elegir mes',
    selectDay: 'Elegir día',
    selectHour: 'Elegir hora',
    selectMinute: 'Elegir minuto',
    gender: 'Género',
    male: 'Hombre',
    female: 'Mujer',
    calculate: 'Abrir lectura',
    calculating: 'Calculando...',
    recalculate: 'Calcular de nuevo',
    reset: 'Restablecer',
    hideForm: '▲ Ocultar datos de nacimiento',
    showForm: '▼ Editar datos de nacimiento',
    validationError: 'Completa la fecha y hora de nacimiento',
    calcError: 'No se pudo calcular. Revisa los datos o inténtalo más tarde',
    chatTitle: '💬 Consulta de destino',
    chatPlaceholder: 'Escribe tu pregunta...',
    chatSend: 'Enviar',
    chatError: 'Lo siento, ahora no puedo responder. Inténtalo más tarde.',
    q1: '¿Qué tan fuerte es mi day master?',
    q2: '¿Qué carrera me conviene?',
    q3: '¿Cuándo favorece el matrimonio?',
    q4: '¿Qué consejo hay para la riqueza?',
    q5: '¿Qué debo vigilar en salud?',
    resumeTitle: 'Yuanhai Ziping Bazi',
    tabAi: 'Preguntas',
    tabOriginal: 'Original Texto clásico',
    tabModern: 'Modern Explicación',
    readingTabsLabel: 'Modo de lectura de carta',
    modernTitle: 'Explicación moderna',
    modernDesc: 'Esta parte convierte el texto clásico en lenguaje cotidiano: energía central, equilibrio de elementos, diez dioses, ciclos de suerte e imagen Guiguzi.',
    modernCoreTitle: 'Energía central de la carta',
    modernCoreCopy: 'Esta carta toma “{dayMaster}” como el yo. El mandato mensual es “{month}” y la fuerza general es “{strength}”. En palabras simples, muestra la forma natural de enfrentar el mundo y los ambientes que más mueven la fortuna.',
    modernFiveTitle: 'Cinco elementos y señales útiles/de cautela',
    modernFiveCopy: 'El elemento más visible es “{dominant}”; el lado más ligero o faltante es “{missing}”. La carta se beneficia de “{useful}”, mientras “{caution}” pide decidir con más calma.',
    modernUsefulCopy: 'Los elementos útiles no son una garantía absoluta. Son una pista de equilibrio: elegir dirección, aliados, momento y ritmo de vida que compensen la carta.',
    modernTenGodsTitle: 'Diez dioses en lenguaje claro',
    modernTenGodsCopy: 'Los diez dioses son fuerzas de rol en la vida: recursos, presión, expresión, riqueza, relaciones y pares. Su pilar muestra dónde suelen aparecer.',
    modernLifeTitle: 'Temperamento y señales de salud',
    modernLuckTitle: 'Ritmo de los ciclos de suerte',
    modernLuckCopy: 'Los pilares de suerte no son un veredicto de un solo año. Cada pilar de diez años es como clima de fondo, amplificando o suavizando el patrón original.',
    modernGuiguziTitle: 'Guiguzi Liangtoujian en lenguaje claro',
    modernGuiguziCopy: 'La llave Guiguzi es “{symbol}” y corresponde a “{match}”. En palabras simples, es una carta simbólica de vida: desafíos repetidos, giros y la forma en que los eventos responden a la persona.',
    none: 'Ninguno',
    baziTitle: 'Destino integrado',
    zipingTitle: 'Yuanhai Ziping Bazi',
    zipingMethod: 'El day stem se lee como el yo; se interpretan mandato mensual, diez dioses, tallos ocultos, cinco elementos y elementos útiles.',
    methodBasis: 'Método',
    classicalText: 'Clásico',
    plainText: 'Lenguaje claro',
    dayMasterAndMonth: 'Day master y mes',
    monthCommand: 'Mandato mensual',
    strength: 'Fuerza',
    strengthScore: 'Puntuación',
    dominantElement: 'Elemento dominante',
    missingElements: 'Elementos faltantes',
    usefulElements: 'Elementos útiles',
    cautionElements: 'Elementos con cautela',
    dayEmpty: 'Ramas vacías',
    element: 'Elemento',
    hiddenStems: 'Tallos ocultos',
    tenGodsTitle: 'Diez dioses visibles',
    hiddenStemsTitle: 'Tallos ocultos',
    fiveElementsTitle: 'Equilibrio de cinco elementos',
    personalityHealthTitle: 'Temperamento y señales de salud',
    liangtoujianTitle: '📜 Guiguzi Liangtoujian',
    liangtoujianMethod: 'Los cuatro pilares se calculan por términos solares; tallo del año y tallo de la hora forman la llave.',
    symbolHeads: 'Llave',
    matchingKey: 'Signo ligado',
    gua: 'Gua',
    matchedReading: 'Lectura clásica',
    star: 'Estrella',
    starCombinations: 'Lecturas de estrellas',
    selectedLifeGate: 'Puerta de destino',
    yearPillar: 'Pilar del año',
    monthPillar: 'Pilar del mes',
    dayPillar: 'Pilar del día',
    hourPillar: 'Pilar de la hora',
    dayMaster: 'Day master',
    guiguziTitle: '📜 Guiguzi Liangtoujian',
    judgement: 'Juicio',
    pattern: 'Patrón',
    predictions: 'Predicciones',
    luckPillars: '🔄 Pilares de suerte',
    startAge: 'Edad inicial',
    direction: 'Dirección',
    solar: 'Solar',
    lunar: 'Lunar',
    wealthLabel: 'Riqueza',
    descendants: 'Descendencia',
    achievement: 'Logro',
    careerLabel: 'Carrera',
    detail: 'Detalle',
    matched: 'Correspondencia',
    ganZhi: 'Tallo-rama',
    mingGe: 'Tipo de destino',
    explanation: 'Explicación',
    startLuck: 'Inicio de suerte',
    prosperous: 'Fortuna fuerte',
    caution: 'Actuar con cautela',
    marriageLuck: 'Suerte matrimonial',
    childrenLuck: 'Suerte de hijos',
    chengguTitle: '⚖️ Peso óseo de Yuan Tiangang',
    chengguMethod: 'El año, mes, día y hora lunares reciben un peso. La suma se compara con el verso de peso óseo.',
    boneWeight: 'Peso óseo',
    boneWeightBreakdown: 'Detalle de peso',
    totalBoneWeight: 'Peso total',
    boneSong: 'Verso de peso óseo',
    boneAnnotation: 'Comentario',
    birthLunarDate: 'Nacimiento lunar',
    yearWeight: 'Peso del año',
    monthWeight: 'Peso del mes',
    dayWeight: 'Peso del día',
    hourWeight: 'Peso de la hora',
    modernChengguTitle: 'Yuan Tiangang en lenguaje claro',
    modernChengguCopy: 'Esta carta pesa “{weight}” y corresponde a “{label}”. En palabras simples, los cuatro pesos de nacimiento forman un patrón de vida, y Bazi con los ciclos de suerte afina la lectura.',
  },
});

Object.assign(translations['zh-TW'], {
  chatTitle: '💬 神明回答',
  tabModern: '現代解釋 Modern',
  modernTitle: '現代解釋',
  modernDesc: '以下用白話說清楚：先看出身和性格，再給職業方向、發展重點、流年、十年大運和五項命格。',
  modernLifeCourseTitle: '一生運程',
  modernLifeCourseCopy: '早年根基看年柱和月柱。此命以「{dayMaster}」為自己，月令「{month}」，旺衰為「{strength}」。性格重點是：{personality} 改運重點很直接：多用「{useful}」的方向，少碰「{caution}」過重的事。',
  modernYearlyTitle: '流年運程',
  modernYearlyCopy: '以下按年份干支，配合命盤喜用與慎用五行，推看近年氣勢。分數只作起伏提示，重點看哪一年宜進、哪一年宜守。',
  modernTenYearTitle: '十年大運',
  modernTenYearCopy: '大運自「{startAge}」起，每十年一換。分數高可主動爭取工作、感情和錢財。分數低先守住現金流、健康和人際。',
  modernFateTitle: '命格',
  modernFamilyTitle: '家庭',
  modernWealthTitle: '財富',
  modernMarriageTitle: '婚姻',
  modernCareerTitle: '事業',
  modernHealthTitle: '健康',
  modernFamilyCopy: '家庭方面，先看早年支援是否足夠。若家中助力弱，就要早點建立自己的圈子和收入。',
  modernWealthCopy: '財富方面，宜把錢放在「{area}」相關能力上。先靠正職和專長穩定收入，再談投資。',
  modernMarriageCopy: '婚姻方面，重點是溝通和責任分配。感情不要只看感覺，要看對方是否能一起面對生活。',
  modernCareerCopy: '事業方面，可先試「{occupation}」。發展「{area}」。下一步：{action}',
  modernHealthCopy: '健康方面，先守睡眠、飲食和壓力。命理只作提醒，身體不適仍要看醫生。',
  yearlyNote: '{year}（{ganzhi}）：{tone}。{reason}',
  annualUsefulReason: '流年帶「{elements}」之氣，與命盤喜用相應。',
  annualCautionReason: '流年帶「{elements}」之氣，與命盤慎用相觸，宜保守。',
  annualSteadyReason: '流年五行不偏不激，宜守正慢行。',
  luckPillarNote: '{range}歲行「{pillar}」運，屬「{tenGod}」。{plain}',
  luckExplainMore: '解釋更多',
  luckExplainLoading: '細解中...',
  luckExplainError: '暫時未能細解此段大運，請稍後再試。',
  plainLanguageName: '繁體中文',
  steady: '平穩',
});

Object.assign(translations['zh-CN'], {
  chatTitle: '💬 神明回答',
  tabModern: '现代解释 Modern',
  modernTitle: '现代解释',
  modernDesc: '以下用白话说清楚：先看出身和性格，再给职业方向、发展重点、流年、十年大运和五项命格。',
  modernLifeCourseTitle: '一生运程',
  modernLifeCourseCopy: '早年根基看年柱和月柱。此命以“{dayMaster}”为自己，月令“{month}”，旺衰为“{strength}”。性格重点是：{personality} 改运重点很直接：多用“{useful}”的方向，少碰“{caution}”过重的事。',
  modernYearlyTitle: '流年运程',
  modernYearlyCopy: '以下按年份干支，配合命盘喜用与慎用五行，推看近年气势。分数只作起伏提示，重点看哪一年宜进、哪一年宜守。',
  modernTenYearTitle: '十年大运',
  modernTenYearCopy: '大运自“{startAge}”起，每十年一换。分数高可主动争取工作、感情和钱财。分数低先守住现金流、健康和人际。',
  modernFateTitle: '命格',
  modernFamilyTitle: '家庭',
  modernWealthTitle: '财富',
  modernMarriageTitle: '婚姻',
  modernCareerTitle: '事业',
  modernHealthTitle: '健康',
  modernFamilyCopy: '家庭方面，先看早年支持是否足够。若家中助力弱，就要早点建立自己的圈子和收入。',
  modernWealthCopy: '财富方面，宜把钱放在“{area}”相关能力上。先靠正职和专长稳定收入，再谈投资。',
  modernMarriageCopy: '婚姻方面，重点是沟通和责任分配。感情不要只看感觉，要看对方是否能一起面对生活。',
  modernCareerCopy: '事业方面，可先试“{occupation}”。发展“{area}”。下一步：{action}',
  modernHealthCopy: '健康方面，先守睡眠、饮食和压力。命理只作提醒，身体不适仍要看医生。',
  yearlyNote: '{year}（{ganzhi}）：{tone}。{reason}',
  annualUsefulReason: '流年带“{elements}”之气，与命盘喜用相应。',
  annualCautionReason: '流年带“{elements}”之气，与命盘慎用相触，宜保守。',
  annualSteadyReason: '流年五行不偏不激，宜守正慢行。',
  luckPillarNote: '{range}岁行“{pillar}”运，属“{tenGod}”。{plain}',
  luckExplainMore: '解释更多',
  luckExplainLoading: '细解中...',
  luckExplainError: '暂时未能细解此段大运，请稍后再试。',
  plainLanguageName: '简体中文',
  steady: '平稳',
});

Object.assign(translations.en, {
  chatTitle: '💬 Divine Answer',
  tabModern: 'Modern Explanation',
  modernTitle: 'Modern Explanation',
  modernDesc: 'A simple reading: background, personality, practical career direction, yearly flow, ten-year cycles and five life areas.',
  modernLifeCourseTitle: 'Life course',
  modernLifeCourseCopy: 'Early support is read from the year and month pillars. This chart takes “{dayMaster}” as the self, with month command “{month}” and strength “{strength}”. Personality clue: {personality} The practical rule is simple: build toward “{useful}” and be careful when “{caution}” becomes too strong.',
  modernYearlyTitle: 'Yearly fortune',
  modernYearlyCopy: 'The yearly stem-branch is compared with the chart’s useful and caution elements. The score shows rhythm only: which years invite movement, and which years ask for patience.',
  modernTenYearTitle: 'Ten-year luck cycles',
  modernTenYearCopy: 'Luck begins at “{startAge}”. Each cycle lasts ten years. Higher scores favor taking chances in work, money and love. Lower scores favor cashflow, health and relationship control.',
  modernFateTitle: 'Destiny pattern',
  modernFamilyTitle: 'Family',
  modernWealthTitle: 'Wealth',
  modernMarriageTitle: 'Marriage',
  modernCareerTitle: 'Career',
  modernHealthTitle: 'Health',
  modernFamilyCopy: 'For family, first check whether early support is strong. If support is weak, build your own circle and income earlier.',
  modernWealthCopy: 'For money, invest in skills around “{area}”. Stabilize income through work and expertise before taking investment risk.',
  modernMarriageCopy: 'For marriage, focus on communication and shared responsibility. Do not judge only by feeling; check whether both can handle real life together.',
  modernCareerCopy: 'For career, try “{occupation}” first. Develop “{area}”. Next step: {action}',
  modernHealthCopy: 'For health, protect sleep, food and stress. This is symbolic advice only; see a doctor for real symptoms.',
  yearlyNote: '{year} ({ganzhi}): {tone}. {reason}',
  annualUsefulReason: 'The year carries “{elements}”, echoing the chart’s useful energy.',
  annualCautionReason: 'The year carries “{elements}”, touching caution energy; move conservatively.',
  annualSteadyReason: 'The year is neither too sharp nor too weak; steady action is favored.',
  luckPillarNote: 'Age {range}, “{pillar}” cycle, ten-god “{tenGod}”. {plain}',
  luckExplainMore: 'Explain More',
  luckExplainLoading: 'Explaining...',
  luckExplainError: 'This luck cycle cannot be explained right now. Please try again later.',
  plainLanguageName: 'English',
  steady: 'Steady',
});

Object.assign(translations.ko, {
  chatTitle: '💬 신명의 응답',
  tabAi: '신명의 응답',
  tabModern: '현대 풀이',
  modernTitle: '현대 풀이',
  modernDesc: '쉽게 봅니다: 배경, 성격, 구체적인 직업 방향, 연운, 십 년 대운, 다섯 생활 영역.',
  modernLifeCourseTitle: '일생 운정',
  modernLifeCourseCopy: '초년의 도움은 년주와 월주로 봅니다. 이 명반은 “{dayMaster}”를 자신으로 보고, 월령은 “{month}”, 왕쇠는 “{strength}”입니다. 성격 힌트: {personality} 실천법은 단순합니다. “{useful}” 방향을 키우고 “{caution}”이 강할 때는 조심하세요.',
  modernYearlyTitle: '연도별 운세',
  modernYearlyCopy: '해마다의 간지를 명반의 희용·주의 오행과 맞추어 봅니다. 점수는 리듬을 보여줄 뿐이며, 움직일 해와 지킬 해를 가르는 힌트입니다.',
  modernTenYearTitle: '십 년 대운',
  modernTenYearCopy: '대운은 “{startAge}”부터 십 년마다 바뀝니다. 점수가 높으면 일·돈·연애를 적극적으로 잡고, 낮으면 현금흐름·건강·관계를 먼저 지키세요.',
  modernFateTitle: '명격',
  modernFamilyTitle: '가족',
  modernWealthTitle: '재물',
  modernMarriageTitle: '혼인',
  modernCareerTitle: '직업',
  modernHealthTitle: '건강',
  modernFamilyCopy: '가족은 초년의 도움을 먼저 봅니다. 도움이 약하면 일찍 자기 인맥과 수입원을 만들어야 합니다.',
  modernWealthCopy: '돈은 “{area}” 능력에 투자하는 쪽이 좋습니다. 투자보다 직업 수입과 전문성을 먼저 안정시키세요.',
  modernMarriageCopy: '혼인은 대화와 책임 분담이 핵심입니다. 감정보다 함께 생활을 감당할 수 있는지를 보세요.',
  modernCareerCopy: '직업은 먼저 “{occupation}”을 시도하세요. “{area}”를 키우세요. 다음 행동: {action}',
  modernHealthCopy: '건강은 수면, 식사, 스트레스를 먼저 지키세요. 실제 증상은 반드시 의학적으로 확인하세요.',
  yearlyNote: '{year}（{ganzhi}）：{tone}. {reason}',
  annualUsefulReason: '그 해에는 “{elements}” 기운이 있어 명반의 희용과 맞닿습니다.',
  annualCautionReason: '그 해에는 “{elements}” 기운이 있어 주의할 기운과 부딪히므로 보수적으로 움직이세요.',
  annualSteadyReason: '오행이 크게 치우치지 않아 바른 길을 천천히 가는 해입니다.',
  luckPillarNote: '{range}세 “{pillar}” 대운, 십신은 “{tenGod}”. {plain}',
  luckExplainMore: '더 자세히 보기',
  luckExplainLoading: '풀이 중...',
  luckExplainError: '지금은 이 대운을 자세히 풀이할 수 없습니다. 잠시 후 다시 시도하세요.',
  plainLanguageName: '한국어',
  steady: '평온',
  annualFortuneTitle: '연도별 운세',
  annualFortuneBrief: '연간 운세는 입춘을 한 해의 경계로 삼고 본명 띠와 태세의 관계를 봅니다. 여기서는 전년, 금년, 내년의 흐름을 한눈에 보여줍니다.',
  viewAnnualDetails: '연도별 운세 자세히 보기',
  annualPageTitle: '연도별 운세',
  annualPageDesc: '양력 생년월일시를 입력하면 본명 띠를 세우고, 전년·금년·내년 태세를 기준으로 전체 운세와 가족, 재물, 혼인, 직업, 건강 및 열두 달 흐름을 봅니다.',
  annualYearTabsLabel: '연도별 운세',
  previousLunarYear: '전년',
  currentLunarYear: '금년',
  nextLunarYear: '내년',
  taiSui: '태세',
  relationship: '관계',
  luckyStars: '길성',
  unluckyStars: '흉성',
  overallFortune: '전체 운세',
  annualOverallNarrativeTitle: '한 해 총론',
  categoryFortune: '다섯 분야 운세',
  monthlyDevelopment: '월별 흐름',
  specificDevelopment: '구체 흐름',
  monthFortuneChart: '월별 운세 그래프',
  monthlyScrollHint: '가로로 밀어 열두 음력 흐름달을 확인하세요. 출생 정보는 양력으로 입력하고, 월별 카드는 절기 기준의 음력 달 순서를 따릅니다.',
  calendarBasis: '달력 기준',
  lunarCalendarLabel: '음력 흐름달',
  gregorianInputLabel: '양력 출생 입력',
  backToIntegrated: '종합 명리로 돌아가기',
});

Object.assign(translations.ja, {
  chatTitle: '💬 神明の答え',
  tabAi: '神明の答え',
  tabModern: '現代解釈',
  modernTitle: '現代解釈',
  modernDesc: '出身、性格、具体的な仕事の方向、年運、十年大運、五つの生活面をやさしく読みます。',
  modernLifeCourseTitle: '一生の運程',
  modernLifeCourseCopy: '早年の支えは年柱と月柱で見ます。この命盤は「{dayMaster}」を自分自身とし、月令は「{month}」、旺衰は「{strength}」です。性格のヒント：{personality} 実践は単純です。「{useful}」の方向を伸ばし、「{caution}」が強い時は慎重に。',
  modernYearlyTitle: '流年運',
  modernYearlyCopy: '各年の干支を、命盤の喜用と慎む五行に照らして見ます。点数は流れの目安で、進む年と守る年を読むためのものです。',
  modernTenYearTitle: '十年大運',
  modernTenYearCopy: '大運は「{startAge}」から十年ごとに変わります。点数が高い時は仕事・お金・恋愛を取りに行き、低い時は資金、健康、人間関係を守りましょう。',
  modernFateTitle: '命格',
  modernFamilyTitle: '家族',
  modernWealthTitle: '財',
  modernMarriageTitle: '婚姻',
  modernCareerTitle: '仕事',
  modernHealthTitle: '健康',
  modernFamilyCopy: '家族は早年の支援を見ます。支えが弱いなら、自分の人脈と収入を早めに作ること。',
  modernWealthCopy: '財は「{area}」の能力に投資するのが良いです。投資より先に仕事収入と専門性を安定させましょう。',
  modernMarriageCopy: '婚姻は会話と責任分担が大事です。気持ちだけでなく、生活を共に担える相手かを見ましょう。',
  modernCareerCopy: '仕事はまず「{occupation}」を試すこと。「{area}」を伸ばすこと。次の一手：{action}',
  modernHealthCopy: '健康は睡眠、食事、ストレスを先に守りましょう。実際の症状は医療確認を優先してください。',
  yearlyNote: '{year}（{ganzhi}）：{tone}。{reason}',
  annualUsefulReason: '流年に「{elements}」の気があり、命盤の喜用と響き合います。',
  annualCautionReason: '流年に「{elements}」の気があり、慎む気に触れるため守りを重んじます。',
  annualSteadyReason: '五行が大きく偏らず、正道をゆっくり進む年です。',
  luckPillarNote: '{range}歳は「{pillar}」の大運、十神は「{tenGod}」。{plain}',
  luckExplainMore: 'さらに詳しく',
  luckExplainLoading: '詳しく解釈中...',
  luckExplainError: '現在、この大運を詳しく解釈できません。後でもう一度お試しください。',
  plainLanguageName: '日本語',
  steady: '平穏',
  annualFortuneTitle: '流年運',
  annualFortuneBrief: '流年は立春を年の境目とし、本命生肖と太歳の関係を読みます。ここでは前年、今年、来年の流れを一覧します。',
  viewAnnualDetails: '流年運の詳解を見る',
  annualPageTitle: '流年運',
  annualPageDesc: '西暦の生年月日時を入力すると本命生肖を立て、前年・今年・来年の太歳を三局として、全体、家族、財、婚姻、仕事、健康、十二か月の流れを読みます。',
  annualYearTabsLabel: '流年の年',
  previousLunarYear: '前年',
  currentLunarYear: '今年',
  nextLunarYear: '来年',
  taiSui: '太歳',
  relationship: '関係',
  luckyStars: '吉星',
  unluckyStars: '凶星',
  overallFortune: '全体運',
  annualOverallNarrativeTitle: '一年総論',
  categoryFortune: '五項目の運',
  monthlyDevelopment: '月別展開',
  specificDevelopment: '具体展開',
  monthFortuneChart: '月別運勢図',
  monthlyScrollHint: '横にスクロールして十二の流月を確認できます。出生情報は西暦で入力し、月カードは節気に基づく旧暦月順で表示します。',
  calendarBasis: '暦の基準',
  lunarCalendarLabel: '旧暦流月',
  gregorianInputLabel: '西暦出生入力',
  backToIntegrated: '総合命理へ戻る',
});

Object.assign(translations.ms, {
  chatTitle: '💬 Jawapan dewa',
  tabAi: 'Jawapan dewa',
  tabModern: 'Tafsiran moden',
  modernTitle: 'Tafsiran moden',
  modernDesc: 'Bacaan mudah: latar awal, watak, arah kerja yang jelas, nasib tahunan, kitaran sepuluh tahun dan lima bidang hidup.',
  modernLifeCourseTitle: 'Perjalanan hidup',
  modernLifeCourseCopy: 'Sokongan awal dibaca daripada tiang tahun dan bulan. Carta ini membaca “{dayMaster}” sebagai diri, arahan bulan “{month}”, kekuatan “{strength}”. Petunjuk watak: {personality} Cara praktikal: bina arah “{useful}” dan berhati-hati apabila “{caution}” terlalu kuat.',
  modernYearlyTitle: 'Nasib tahunan',
  modernYearlyCopy: 'Stem-branch setiap tahun dibandingkan dengan unsur berguna dan unsur berjaga-jaga dalam carta. Skor hanya menunjukkan rentak: tahun sesuai bergerak dan tahun lebih baik bertahan.',
  modernTenYearTitle: 'Kitaran sepuluh tahun',
  modernTenYearCopy: 'Nasib besar bermula pada “{startAge}” dan berubah setiap sepuluh tahun. Skor tinggi sesuai mengejar kerja, wang dan cinta. Skor rendah jaga tunai, kesihatan dan hubungan dahulu.',
  modernFateTitle: 'Corak nasib',
  modernFamilyTitle: 'Keluarga',
  modernWealthTitle: 'Rezeki',
  modernMarriageTitle: 'Perkahwinan',
  modernCareerTitle: 'Kerjaya',
  modernHealthTitle: 'Kesihatan',
  modernFamilyCopy: 'Untuk keluarga, lihat sama ada sokongan awal cukup. Jika lemah, bina rangkaian dan pendapatan sendiri lebih awal.',
  modernWealthCopy: 'Untuk wang, laburkan masa pada kemahiran “{area}”. Stabilkan gaji dan kepakaran dahulu sebelum ambil risiko pelaburan.',
  modernMarriageCopy: 'Untuk perkahwinan, fokus pada komunikasi dan pembahagian tanggungjawab. Jangan ikut rasa sahaja; lihat sama ada boleh hidup bersama secara nyata.',
  modernCareerCopy: 'Untuk kerjaya, cuba “{occupation}” dahulu. Kembangkan “{area}”. Langkah seterusnya: {action}',
  modernHealthCopy: 'Untuk kesihatan, jaga tidur, makan dan tekanan. Jika ada simptom sebenar, dapatkan pemeriksaan perubatan.',
  yearlyNote: '{year} ({ganzhi}): {tone}. {reason}',
  annualUsefulReason: 'Tahun ini membawa unsur “{elements}”, selari dengan tenaga berguna carta.',
  annualCautionReason: 'Tahun ini membawa unsur “{elements}”, menyentuh tenaga yang perlu dijaga; bergerak secara konservatif.',
  annualSteadyReason: 'Unsur tahun ini tidak terlalu berat sebelah; langkah stabil lebih baik.',
  luckPillarNote: 'Umur {range}, kitaran “{pillar}”, ten-god “{tenGod}”. {plain}',
  luckExplainMore: 'Terangkan lagi',
  luckExplainLoading: 'Sedang menghuraikan...',
  luckExplainError: 'Kitaran ini belum dapat dihuraikan sekarang. Sila cuba lagi kemudian.',
  plainLanguageName: 'Bahasa Malaysia',
  steady: 'Stabil',
  annualFortuneTitle: 'Nasib tahunan',
  annualFortuneBrief: 'Nasib tahunan memakai Li Chun sebagai sempadan tahun dan membandingkan zodiak kelahiran dengan Tai Sui. Ringkasan ini menunjukkan tahun lalu, tahun semasa dan tahun depan.',
  viewAnnualDetails: 'Lihat butiran nasib tahunan',
  annualPageTitle: 'Nasib tahunan',
  annualPageDesc: 'Masukkan tarikh dan masa lahir Gregorian untuk mendapatkan zodiak kelahiran, kemudian baca Tai Sui tahun lalu, semasa dan depan: keseluruhan, keluarga, rezeki, perkahwinan, kerjaya, kesihatan dan perkembangan dua belas bulan lunar.',
  annualYearTabsLabel: 'Tahun nasib',
  previousLunarYear: 'Tahun lalu',
  currentLunarYear: 'Tahun semasa',
  nextLunarYear: 'Tahun depan',
  taiSui: 'Tai Sui',
  relationship: 'Hubungan',
  luckyStars: 'Bintang baik',
  unluckyStars: 'Bintang buruk',
  overallFortune: 'Nasib keseluruhan',
  annualOverallNarrativeTitle: 'Ringkasan tahun',
  categoryFortune: 'Nasib lima bidang',
  monthlyDevelopment: 'Perkembangan bulanan',
  specificDevelopment: 'Perkembangan khusus',
  monthFortuneChart: 'Carta nasib bulanan',
  monthlyScrollHint: 'Tatal mendatar untuk melihat dua belas bulan lunar. Butiran lahir dimasukkan dalam kalendar Gregorian, manakala kad bulan mengikut susunan bulan lunar-solar.',
  calendarBasis: 'Asas kalendar',
  lunarCalendarLabel: 'Bulan lunar',
  gregorianInputLabel: 'Input lahir Gregorian',
  backToIntegrated: 'Kembali ke Metafizik Bersepadu',
});

Object.assign(translations.es, {
  chatTitle: '💬 Respuesta divina',
  tabAi: 'Respuesta divina',
  tabModern: 'Explicación moderna',
  modernTitle: 'Explicación moderna',
  modernDesc: 'Lectura simple: origen, personalidad, dirección laboral concreta, fortuna anual, ciclos de diez años y cinco áreas de vida.',
  modernLifeCourseTitle: 'Curso de vida',
  modernLifeCourseCopy: 'El apoyo temprano se lee desde los pilares de año y mes. Esta carta toma “{dayMaster}” como el yo, con mandato mensual “{month}” y fuerza “{strength}”. Clave de personalidad: {personality} La regla práctica: desarrolla “{useful}” y ten cuidado cuando “{caution}” sea demasiado fuerte.',
  modernYearlyTitle: 'Fortuna anual',
  modernYearlyCopy: 'El tallo-rama de cada año se compara con los elementos útiles y de cautela de la carta. La puntuación solo marca ritmo: qué años invitan a avanzar y cuáles piden guardar.',
  modernTenYearTitle: 'Ciclos de diez años',
  modernTenYearCopy: 'La suerte mayor empieza en “{startAge}” y cambia cada diez años. Puntajes altos favorecen trabajo, dinero y amor. Puntajes bajos piden cuidar flujo de caja, salud y relaciones.',
  modernFateTitle: 'Patrón de destino',
  modernFamilyTitle: 'Familia',
  modernWealthTitle: 'Riqueza',
  modernMarriageTitle: 'Matrimonio',
  modernCareerTitle: 'Carrera',
  modernHealthTitle: 'Salud',
  modernFamilyCopy: 'En familia, mira si el apoyo temprano es suficiente. Si no, construye antes tu propio círculo e ingreso.',
  modernWealthCopy: 'En dinero, invierte en habilidades de “{area}”. Estabiliza ingreso y especialidad antes de tomar riesgo financiero.',
  modernMarriageCopy: 'En matrimonio, prioriza comunicación y reparto de responsabilidad. No mires solo la emoción; mira si ambos sostienen la vida real.',
  modernCareerCopy: 'En carrera, prueba primero “{occupation}”. Desarrolla “{area}”. Siguiente paso: {action}',
  modernHealthCopy: 'En salud, protege sueño, comida y estrés. Si hay síntomas reales, consulta a un médico.',
  yearlyNote: '{year} ({ganzhi}): {tone}. {reason}',
  annualUsefulReason: 'El año trae “{elements}”, en sintonía con la energía útil de la carta.',
  annualCautionReason: 'El año trae “{elements}”, tocando energía de cautela; conviene avanzar con prudencia.',
  annualSteadyReason: 'Los elementos del año no son extremos; favorece una marcha estable.',
  luckPillarNote: 'Edad {range}, ciclo “{pillar}”, ten-god “{tenGod}”. {plain}',
  luckExplainMore: 'Explicar más',
  luckExplainLoading: 'Explicando...',
  luckExplainError: 'No se puede explicar este ciclo ahora. Inténtalo de nuevo más tarde.',
  plainLanguageName: 'español',
  steady: 'Estable',
  annualFortuneTitle: 'Fortuna anual',
  annualFortuneBrief: 'La fortuna anual usa Li Chun como frontera del año y compara tu zodiaco natal con Tai Sui. Este resumen muestra el año anterior, actual y siguiente.',
  viewAnnualDetails: 'Ver detalles de fortuna anual',
  annualPageTitle: 'Fortuna anual',
  annualPageDesc: 'Introduce fecha y hora de nacimiento en calendario gregoriano para revelar tu zodiaco natal, luego lee los años Tai Sui anterior, actual y siguiente: fortuna general, familia, riqueza, matrimonio, carrera, salud y doce meses lunares.',
  annualYearTabsLabel: 'Años de fortuna',
  previousLunarYear: 'Año anterior',
  currentLunarYear: 'Año actual',
  nextLunarYear: 'Año siguiente',
  taiSui: 'Tai Sui',
  relationship: 'Relación',
  luckyStars: 'Estrellas favorables',
  unluckyStars: 'Estrellas desfavorables',
  overallFortune: 'Fortuna general',
  annualOverallNarrativeTitle: 'Lectura del año',
  categoryFortune: 'Fortuna en cinco áreas',
  monthlyDevelopment: 'Desarrollo mensual',
  specificDevelopment: 'Desarrollo específico',
  monthFortuneChart: 'Gráfico mensual',
  monthlyScrollHint: 'Desplázate horizontalmente para ver los doce meses lunares. Los datos de nacimiento se ingresan en calendario gregoriano, mientras las tarjetas siguen el orden lunar-solar.',
  calendarBasis: 'Base del calendario',
  lunarCalendarLabel: 'Mes lunar',
  gregorianInputLabel: 'Nacimiento gregoriano',
  backToIntegrated: 'Volver a Destino integrado',
});

Object.assign(translations['zh-TW'], {
  compatPageTitle: '情侶配對',
  compatPageDesc: '輸入兩個人的公曆出生日期時間與性別。網站先排出兩盤四柱，再按干支配合、五行喜忌、夫妻宮、生肖沖合與十神互動，細看是否相配。',
  compatPersonA: '第一位',
  compatPersonB: '第二位',
  compatBirthDateLabel: '出生日期',
  compatBirthDatePlaceholder: '請選擇日期',
  compatBirthTimeLabel: '出生時間',
  compatBirthTimePlaceholder: 'HH:MM',
  compatCalculate: '立即合婚',
  compatValidationError: '請完整填寫兩個人的出生日期時間',
  compatCalcError: '配對計算失敗，請檢查輸入或稍後再試',
  compatBirthSummary: '兩人出生資料',
  compatEdit: '修改配對資料',
  compatOverall: '總體配對',
  compatChartsTitle: '兩人命盤',
  compatPairFortunesTitle: '雙方大運與流年',
  compatPairFortunesDesc: '兩人的十年大運與前後三個流年已先由程式排出，提問時會一併交給神明回答作背景。',
  compatLuckStart: '起運',
  compatAnnualPreview: '今年流年',
  compatYearWindow: '前後三年',
  compatAspectTitle: '分項詳解',
  compatEvidence: '依據',
  compatAdvice: '建議',
  compatMethodTitle: '取法依據',
  compatSignsTitle: '沖合提示',
  compatFinalAdvice: '總建議',
  compatNoMajorSigns: '無明顯大沖大合',
  compatNoMajorSignsCopy: '此局重點在五行喜忌與日常經營，不宜只用生肖斷吉凶。',
});

Object.assign(translations['zh-CN'], {
  compatPageTitle: '情侣配对',
  compatPageDesc: '输入两个人的公历出生日期时间与性别。网站先排出两盘四柱，再按干支配合、五行喜忌、夫妻宫、生肖冲合与十神互动，细看是否相配。',
  compatPersonA: '第一位',
  compatPersonB: '第二位',
  compatBirthDateLabel: '出生日期',
  compatBirthDatePlaceholder: '请选择日期',
  compatBirthTimeLabel: '出生时间',
  compatBirthTimePlaceholder: 'HH:MM',
  compatCalculate: '立即合婚',
  compatValidationError: '请完整填写两个人的出生日期时间',
  compatCalcError: '配对计算失败，请检查输入或稍后再试',
  compatBirthSummary: '两人出生资料',
  compatEdit: '修改配对资料',
  compatOverall: '总体配对',
  compatChartsTitle: '两人命盘',
  compatPairFortunesTitle: '双方大运与流年',
  compatPairFortunesDesc: '两人的十年大运与前后三个流年已先由程序排出，提问时会一并交给神明回答作背景。',
  compatLuckStart: '起运',
  compatAnnualPreview: '今年流年',
  compatYearWindow: '前后三年',
  compatAspectTitle: '分项详解',
  compatEvidence: '依据',
  compatAdvice: '建议',
  compatMethodTitle: '取法依据',
  compatSignsTitle: '冲合提示',
  compatFinalAdvice: '总建议',
  compatNoMajorSigns: '无明显大冲大合',
  compatNoMajorSignsCopy: '此局重点在五行喜忌与日常经营，不宜只用生肖断吉凶。',
});

Object.assign(translations.en, {
  compatPageTitle: 'Couple Match',
  compatPageDesc: 'Enter both birth dates, times and genders. The app calculates both Bazi charts, then compares stem-branch pairing, useful elements, spouse palaces, zodiac clashes/harmonies and ten-god interaction.',
  compatPersonA: 'Person A',
  compatPersonB: 'Person B',
  compatBirthDateLabel: 'Birth date',
  compatBirthDatePlaceholder: 'Select date',
  compatBirthTimeLabel: 'Birth time',
  compatBirthTimePlaceholder: 'HH:MM',
  compatCalculate: 'Calculate match',
  compatValidationError: 'Please complete the birth date and time for both people.',
  compatCalcError: 'Compatibility calculation failed. Please check the input or try again later.',
  compatBirthSummary: 'Birth details',
  compatEdit: 'Edit match details',
  compatOverall: 'Overall match',
  compatChartsTitle: 'Two charts',
  compatPairFortunesTitle: 'Both luck cycles and annual fortunes',
  compatPairFortunesDesc: 'The app calculates each person’s ten-year luck cycles plus previous, current and next annual fortunes, then sends them into the divine answer as context.',
  compatLuckStart: 'Luck starts',
  compatAnnualPreview: 'This year',
  compatYearWindow: 'Three-year window',
  compatAspectTitle: 'Detailed aspects',
  compatEvidence: 'Evidence',
  compatAdvice: 'Advice',
  compatMethodTitle: 'Method basis',
  compatSignsTitle: 'Clash and harmony signs',
  compatFinalAdvice: 'Final advice',
  compatNoMajorSigns: 'No major clash or harmony',
  compatNoMajorSignsCopy: 'This match depends more on useful elements and daily effort than zodiac signs alone.',
});

Object.assign(translations.ko, {
  compatPageTitle: '커플 궁합',
  compatPageDesc: '두 사람의 양력 생년월일시와 성별을 입력하면 두 사주를 세우고, 간지 배합·희용 오행·배우자궁·띠의 충합·십신 관계로 궁합을 봅니다.',
  compatPersonA: '첫 번째 사람',
  compatPersonB: '두 번째 사람',
  compatBirthDateLabel: '생년월일',
  compatBirthDatePlaceholder: '날짜 선택',
  compatBirthTimeLabel: '출생 시간',
  compatBirthTimePlaceholder: 'HH:MM',
  compatCalculate: '궁합 계산',
  compatValidationError: '두 사람의 생년월일시를 모두 입력해 주세요.',
  compatCalcError: '궁합 계산에 실패했습니다. 입력을 확인하거나 잠시 후 다시 시도하세요.',
  compatBirthSummary: '두 사람 출생 정보',
  compatEdit: '궁합 정보 수정',
  compatOverall: '전체 궁합',
  compatChartsTitle: '두 사람 명반',
  compatPairFortunesTitle: '양쪽 대운과 연운',
  compatPairFortunesDesc: '각 사람의 10년 대운과 전년·금년·내년 운세를 먼저 계산하고, 질문 시 신명 응답의 배경으로 함께 전달합니다.',
  compatLuckStart: '대운 시작',
  compatAnnualPreview: '올해 운세',
  compatYearWindow: '3년 흐름',
  compatAspectTitle: '세부 풀이',
  compatEvidence: '근거',
  compatAdvice: '조언',
  compatMethodTitle: '풀이 근거',
  compatSignsTitle: '충합 표시',
  compatFinalAdvice: '종합 조언',
  compatNoMajorSigns: '큰 충합 없음',
  compatNoMajorSignsCopy: '이 궁합은 띠 하나보다 오행 희기와 생활 운영이 더 중요합니다.',
});

Object.assign(translations.ja, {
  compatPageTitle: '恋人相性',
  compatPageDesc: '二人の西暦出生日時と性別を入力すると、二つの四柱命盤を出し、干支配合・喜用五行・配偶者宮・生肖の冲合・十神関係で相性を読みます。',
  compatPersonA: '一人目',
  compatPersonB: '二人目',
  compatBirthDateLabel: '生年月日',
  compatBirthDatePlaceholder: '日付を選択',
  compatBirthTimeLabel: '出生時間',
  compatBirthTimePlaceholder: 'HH:MM',
  compatCalculate: '相性を計算',
  compatValidationError: '二人分の出生日時をすべて入力してください。',
  compatCalcError: '相性計算に失敗しました。入力を確認し、後でもう一度お試しください。',
  compatBirthSummary: '二人の出生情報',
  compatEdit: '相性情報を修正',
  compatOverall: '総合相性',
  compatChartsTitle: '二人の命盤',
  compatPairFortunesTitle: '双方の大運と流年',
  compatPairFortunesDesc: '二人それぞれの十年大運と前年・今年・来年の流年を先に算出し、質問時に神明回答の背景として渡します。',
  compatLuckStart: '起運',
  compatAnnualPreview: '今年の流年',
  compatYearWindow: '前後三年',
  compatAspectTitle: '項目別詳解',
  compatEvidence: '根拠',
  compatAdvice: '助言',
  compatMethodTitle: '取法根拠',
  compatSignsTitle: '冲合の印',
  compatFinalAdvice: '総合助言',
  compatNoMajorSigns: '大きな冲合なし',
  compatNoMajorSignsCopy: '生肖だけでなく、五行の喜忌と日常の作り方が要点です。',
});

Object.assign(translations.ms, {
  compatPageTitle: 'Padanan pasangan',
  compatPageDesc: 'Masukkan tarikh, masa lahir Gregorian dan jantina untuk dua orang. Aplikasi mengira dua carta Bazi, lalu membandingkan batang-cabang, unsur berguna, istana pasangan, harmoni/pertembungan zodiak dan interaksi ten-god.',
  compatPersonA: 'Orang A',
  compatPersonB: 'Orang B',
  compatBirthDateLabel: 'Tarikh lahir',
  compatBirthDatePlaceholder: 'Pilih tarikh',
  compatBirthTimeLabel: 'Masa lahir',
  compatBirthTimePlaceholder: 'HH:MM',
  compatCalculate: 'Kira padanan',
  compatValidationError: 'Lengkapkan tarikh dan masa lahir untuk kedua-dua orang.',
  compatCalcError: 'Kiraan padanan gagal. Semak input atau cuba lagi nanti.',
  compatBirthSummary: 'Butiran lahir pasangan',
  compatEdit: 'Edit butiran padanan',
  compatOverall: 'Padanan keseluruhan',
  compatChartsTitle: 'Dua carta',
  compatPairFortunesTitle: 'Kitaran nasib dan nasib tahunan kedua-dua pihak',
  compatPairFortunesDesc: 'Aplikasi mengira kitaran 10 tahun serta nasib tahun lalu, semasa dan depan untuk kedua-dua orang, lalu menghantarnya sebagai konteks jawapan dewa.',
  compatLuckStart: 'Mula nasib',
  compatAnnualPreview: 'Tahun ini',
  compatYearWindow: 'Tetingkap tiga tahun',
  compatAspectTitle: 'Butiran aspek',
  compatEvidence: 'Asas',
  compatAdvice: 'Nasihat',
  compatMethodTitle: 'Asas kaedah',
  compatSignsTitle: 'Tanda harmoni dan konflik',
  compatFinalAdvice: 'Nasihat akhir',
  compatNoMajorSigns: 'Tiada konflik atau harmoni besar',
  compatNoMajorSignsCopy: 'Padanan ini lebih bergantung pada unsur berguna dan usaha harian berbanding zodiak sahaja.',
});

Object.assign(translations.es, {
  compatPageTitle: 'Compatibilidad de pareja',
  compatPageDesc: 'Introduce fecha, hora gregoriana y género de dos personas. La app calcula ambas cartas Bazi y compara tallos-ramas, elementos útiles, palacio de pareja, choques/armonías zodiacales e interacción ten-god.',
  compatPersonA: 'Persona A',
  compatPersonB: 'Persona B',
  compatBirthDateLabel: 'Fecha de nacimiento',
  compatBirthDatePlaceholder: 'Seleccionar fecha',
  compatBirthTimeLabel: 'Hora de nacimiento',
  compatBirthTimePlaceholder: 'HH:MM',
  compatCalculate: 'Calcular compatibilidad',
  compatValidationError: 'Completa fecha y hora de nacimiento de ambas personas.',
  compatCalcError: 'Falló el cálculo de compatibilidad. Revisa los datos o inténtalo más tarde.',
  compatBirthSummary: 'Datos de nacimiento',
  compatEdit: 'Editar datos',
  compatOverall: 'Compatibilidad general',
  compatChartsTitle: 'Dos cartas',
  compatPairFortunesTitle: 'Ciclos de suerte y fortuna anual de ambos',
  compatPairFortunesDesc: 'La app calcula los ciclos decenales y las fortunas del año anterior, actual y siguiente de ambos, y los envía como contexto para la respuesta divina.',
  compatLuckStart: 'Inicio de suerte',
  compatAnnualPreview: 'Este año',
  compatYearWindow: 'Ventana de tres años',
  compatAspectTitle: 'Aspectos detallados',
  compatEvidence: 'Base',
  compatAdvice: 'Consejo',
  compatMethodTitle: 'Base del método',
  compatSignsTitle: 'Señales de choque y armonía',
  compatFinalAdvice: 'Consejo final',
  compatNoMajorSigns: 'Sin choque ni armonía mayor',
  compatNoMajorSignsCopy: 'La compatibilidad depende más de elementos útiles y esfuerzo diario que del zodiaco solo.',
});

Object.assign(translations['zh-TW'], {
  namingPageTitle: '起運改名',
  namingPageDesc: '輸入生辰、姓氏與偏好用字。網站後台自動判定康熙筆劃，再起三才五格與八十一數理；字義吉凶、古今諧音與生肖喜忌，交由神明回答細審。',
  namingBirthTitle: '命主生辰',
  namingNameTitle: '姓氏與偏好',
  namingSurname: '姓氏',
  namingGivenName: '名字',
  namingSurnamePlaceholder: '例如：李',
  namingGivenPlaceholder: '例如：明',
  namingStrokeTitle: '康熙筆劃',
  namingStrokeHint: '已預填常見字筆劃；罕見字請按康熙字典筆劃修正。',
  namingCalculate: '立即起名',
  namingCalculating: '起名中...',
  namingValidationError: '請填妥出生日期時間與姓氏；偏好用字可留空。',
  namingCalcError: '起運改名計算失敗，請檢查輸入或稍後再試。',
  namingEdit: '修改姓名',
  namingOverall: '姓名總勢',
  namingFiveGridTitle: '三才五格',
  namingStrokeUnit: '劃',
  namingThreeTalentTitle: '三才配置',
  namingNameMeaning: '名字含義',
  namingAuspiciousScore: '吉凶分',
  namingScoreUnit: '分',
  namingCoreGrids: '核心五格',
  namingReason: '取名理由：',
  namingBaziFitTitle: '八字補益',
  namingUsefulRadicals: '喜用字形',
  namingZodiacLikes: '生肖宜見',
  namingZodiacAvoids: '生肖忌見',
  namingSemanticTitle: '字義吉凶與生肖喜忌',
});

Object.assign(translations['zh-CN'], {
  namingPageTitle: '起运改名',
  namingPageDesc: '输入生辰、姓氏与偏好用字。网站后台自动判定康熙笔画，再起三才五格与八十一数理；字义吉凶、古今谐音与生肖喜忌，交由神明回答细审。',
  namingBirthTitle: '命主生辰',
  namingNameTitle: '姓氏与偏好',
  namingSurname: '姓氏',
  namingGivenName: '名字',
  namingSurnamePlaceholder: '例如：李',
  namingGivenPlaceholder: '例如：明',
  namingStrokeTitle: '康熙笔画',
  namingStrokeHint: '已预填常见字笔画；罕见字请按康熙字典笔画修正。',
  namingCalculate: '立即起名',
  namingCalculating: '起名中...',
  namingValidationError: '请填妥出生日期时间与姓氏；偏好用字可留空。',
  namingCalcError: '起运改名计算失败，请检查输入或稍后再试。',
  namingEdit: '修改姓名',
  namingOverall: '姓名总势',
  namingFiveGridTitle: '三才五格',
  namingStrokeUnit: '画',
  namingThreeTalentTitle: '三才配置',
  namingNameMeaning: '名字含义',
  namingAuspiciousScore: '吉凶分',
  namingScoreUnit: '分',
  namingCoreGrids: '核心五格',
  namingReason: '取名理由：',
  namingBaziFitTitle: '八字补益',
  namingUsefulRadicals: '喜用字形',
  namingZodiacLikes: '生肖宜见',
  namingZodiacAvoids: '生肖忌见',
  namingSemanticTitle: '字义吉凶与生肖喜忌',
});

Object.assign(translations.en, {
  namingPageTitle: 'Destiny Naming',
  namingPageDesc: 'Enter birth details, surname and preferred wording. The backend resolves Kangxi strokes, then calculates San Cai Wu Ge and the 81-number pattern before divine review.',
  namingBirthTitle: 'Birth details',
  namingNameTitle: 'Surname and preference',
  namingSurname: 'Surname',
  namingGivenName: 'Given name',
  namingSurnamePlaceholder: 'e.g. 李',
  namingGivenPlaceholder: 'e.g. 明',
  namingStrokeTitle: 'Kangxi strokes',
  namingStrokeHint: 'Common characters are prefilled. Please correct rare characters by Kangxi dictionary stroke count.',
  namingCalculate: 'Read this name',
  namingCalculating: 'Reading...',
  namingValidationError: 'Please complete birth date/time and surname. Preferred wording can be left blank.',
  namingCalcError: 'Naming calculation failed. Please check the input or try again later.',
  namingEdit: 'Edit name',
  namingOverall: 'Name fortune',
  namingFiveGridTitle: 'San Cai Wu Ge',
  namingStrokeUnit: ' strokes',
  namingThreeTalentTitle: 'Three talents',
  namingNameMeaning: 'Name meaning',
  namingAuspiciousScore: 'Auspicious score',
  namingScoreUnit: 'pts',
  namingCoreGrids: 'Core grids',
  namingReason: 'Reason: ',
  namingBaziFitTitle: 'Bazi fit',
  namingUsefulRadicals: 'Useful radicals',
  namingZodiacLikes: 'Zodiac likes',
  namingZodiacAvoids: 'Zodiac avoids',
  namingSemanticTitle: 'Meaning and zodiac fit',
});

Object.assign(translations.ko, {
  namingPageTitle: '개명 운세',
  namingPageDesc: '출생 정보, 성, 선호 글자를 입력하면 후단에서 강희 획수를 판정하고 삼재오격과 81수리를 계산한 뒤 신명 응답으로 살핍니다.',
  namingBirthTitle: '출생 정보',
  namingNameTitle: '성과 선호 글자',
  namingSurname: '성',
  namingGivenName: '이름',
  namingSurnamePlaceholder: '예: 李',
  namingGivenPlaceholder: '예: 明',
  namingStrokeTitle: '강희 획수',
  namingStrokeHint: '흔한 글자는 자동 입력됩니다. 드문 글자는 강희자전 획수로 수정하세요.',
  namingCalculate: '이름 보기',
  namingCalculating: '풀이 중...',
  namingValidationError: '출생 일시와 성을 입력해 주세요. 선호 글자는 비워도 됩니다.',
  namingCalcError: '개명 계산에 실패했습니다. 입력을 확인하거나 잠시 후 다시 시도하세요.',
  namingEdit: '이름 수정',
  namingOverall: '이름 총운',
  namingFiveGridTitle: '삼재오격',
  namingStrokeUnit: '획',
  namingThreeTalentTitle: '삼재 배치',
  namingNameMeaning: '이름 뜻',
  namingAuspiciousScore: '길흉 점수',
  namingScoreUnit: '점',
  namingCoreGrids: '핵심 오격',
  namingReason: '작명 이유: ',
  namingBaziFitTitle: '사주 보완',
  namingUsefulRadicals: '도움 되는 자형',
  namingZodiacLikes: '띠에 맞는 자형',
  namingZodiacAvoids: '띠가 꺼리는 자형',
  namingSemanticTitle: '뜻과 띠 자형 판정',
});

Object.assign(translations.ja, {
  namingPageTitle: '開運改名',
  namingPageDesc: '出生情報、姓、希望文字を入力すると、後台で康熙画数を判定し、三才五格と八十一数理を計算して神明回答で見ます。',
  namingBirthTitle: '出生情報',
  namingNameTitle: '姓と希望文字',
  namingSurname: '姓',
  namingGivenName: '名',
  namingSurnamePlaceholder: '例：李',
  namingGivenPlaceholder: '例：明',
  namingStrokeTitle: '康熙画数',
  namingStrokeHint: '一般的な字は自動入力されます。珍しい字は康熙字典画数で修正してください。',
  namingCalculate: '姓名を読む',
  namingCalculating: '鑑定中...',
  namingValidationError: '出生日時と姓を入力してください。希望文字は空欄でも構いません。',
  namingCalcError: '改名計算に失敗しました。入力を確認し、後でもう一度お試しください。',
  namingEdit: '姓名を修正',
  namingOverall: '姓名総運',
  namingFiveGridTitle: '三才五格',
  namingStrokeUnit: '画',
  namingThreeTalentTitle: '三才配置',
  namingNameMeaning: '名前の意味',
  namingAuspiciousScore: '吉凶スコア',
  namingScoreUnit: '点',
  namingCoreGrids: '主要五格',
  namingReason: '命名理由：',
  namingBaziFitTitle: '命盤補益',
  namingUsefulRadicals: '喜用字形',
  namingZodiacLikes: '生肖が喜ぶ字形',
  namingZodiacAvoids: '生肖が避ける字形',
  namingSemanticTitle: '字義と生肖字形',
});

Object.assign(translations.ms, {
  namingPageTitle: 'Nama pembawa tuah',
  namingPageDesc: 'Masukkan butiran lahir, nama keluarga dan pilihan aksara. Backend menentukan strok Kangxi, lalu mengira San Cai Wu Ge dan pola 81 nombor sebelum jawapan dewa.',
  namingBirthTitle: 'Butiran lahir',
  namingNameTitle: 'Nama keluarga dan pilihan',
  namingSurname: 'Nama keluarga',
  namingGivenName: 'Nama diberi',
  namingSurnamePlaceholder: 'cth. 李',
  namingGivenPlaceholder: 'cth. 明',
  namingStrokeTitle: 'Strok Kangxi',
  namingStrokeHint: 'Aksara biasa diisi awal. Betulkan aksara jarang mengikut kiraan Kamus Kangxi.',
  namingCalculate: 'Baca nama ini',
  namingCalculating: 'Membaca...',
  namingValidationError: 'Lengkapkan tarikh/masa lahir dan nama keluarga. Pilihan aksara boleh dibiarkan kosong.',
  namingCalcError: 'Kiraan nama gagal. Semak input atau cuba lagi nanti.',
  namingEdit: 'Edit nama',
  namingOverall: 'Nasib nama',
  namingFiveGridTitle: 'San Cai Wu Ge',
  namingStrokeUnit: ' strok',
  namingThreeTalentTitle: 'Tiga bakat',
  namingNameMeaning: 'Maksud nama',
  namingAuspiciousScore: 'Skor baik buruk',
  namingScoreUnit: 'mata',
  namingCoreGrids: 'Grid utama',
  namingReason: 'Sebab: ',
  namingBaziFitTitle: 'Padanan Bazi',
  namingUsefulRadicals: 'Radikal berguna',
  namingZodiacLikes: 'Zodiak suka',
  namingZodiacAvoids: 'Zodiak elak',
  namingSemanticTitle: 'Makna dan padanan zodiak',
});

Object.assign(translations.es, {
  namingPageTitle: 'Nombre propicio',
  namingPageDesc: 'Introduce nacimiento, apellido y preferencia de caracteres. El backend resuelve trazos Kangxi, calcula San Cai Wu Ge y el patrón de 81 números antes de la respuesta divina.',
  namingBirthTitle: 'Datos de nacimiento',
  namingNameTitle: 'Apellido y preferencia',
  namingSurname: 'Apellido',
  namingGivenName: 'Nombre',
  namingSurnamePlaceholder: 'ej. 李',
  namingGivenPlaceholder: 'ej. 明',
  namingStrokeTitle: 'Trazos Kangxi',
  namingStrokeHint: 'Los caracteres comunes se rellenan. Corrige los raros según el diccionario Kangxi.',
  namingCalculate: 'Leer este nombre',
  namingCalculating: 'Leyendo...',
  namingValidationError: 'Completa fecha/hora de nacimiento y apellido. La preferencia de caracteres puede quedar vacía.',
  namingCalcError: 'Falló el cálculo del nombre. Revisa los datos o inténtalo más tarde.',
  namingEdit: 'Editar nombre',
  namingOverall: 'Fortuna del nombre',
  namingFiveGridTitle: 'San Cai Wu Ge',
  namingStrokeUnit: ' trazos',
  namingThreeTalentTitle: 'Tres talentos',
  namingNameMeaning: 'Significado del nombre',
  namingAuspiciousScore: 'Puntuación auspiciosa',
  namingScoreUnit: 'pts',
  namingCoreGrids: 'Cuadros clave',
  namingReason: 'Razón: ',
  namingBaziFitTitle: 'Ajuste Bazi',
  namingUsefulRadicals: 'Radicales útiles',
  namingZodiacLikes: 'El zodiaco prefiere',
  namingZodiacAvoids: 'El zodiaco evita',
  namingSemanticTitle: 'Significado y ajuste zodiacal',
});

Object.assign(translations['zh-TW'], {
  datePageTitle: '擇日',
  datePageDesc: '依《欽定協紀辨方書》取法，先定用事與日期範圍，再合相關人士生辰，逐日看宜忌、吉神凶煞、建除、黃黑道與日沖。',
  dateEventTitle: '用事',
  dateEventLabel: '所辦事項',
  dateEventMarriage: '嫁娶',
  dateEventMoving: '入宅搬遷',
  dateEventOpening: '開市營業',
  dateEventContract: '訂盟簽約',
  dateEventTravel: '出行',
  dateEventWorship: '祭祀祈福',
  dateEventCustom: '自訂事項',
  dateCustomEventLabel: '自訂事項',
  dateCustomEventPlaceholder: '例如：開工、見客、安床',
  dateRangeTitle: '日期範圍',
  dateStartLabel: '開始日期',
  dateEndLabel: '結束日期',
  dateRangeHint: '請用日期選擇器選取公曆日期。每次最多計算 366 日。',
  datePeopleTitle: '相關人士',
  datePeopleHint: '至少加入一位相關人士，輸入角色與生日即可。',
  dateMarriagePeopleHint: '嫁娶至少需要兩位相關人士；可再加入雙方父母等角色。',
  dateAddPerson: '加入人士',
  dateRemovePerson: '移除',
  datePerson: '人士',
  dateRoleLabel: '角色',
  dateRolePlaceholder: '例如：新郎、母親、合作人',
  dateRoleGroom: '新郎',
  dateRoleBride: '新娘',
  dateRoleHomeowner: '戶主',
  dateRoleBoss: '老闆',
  dateRoleSigner: '簽約人',
  dateRoleTraveler: '出行人',
  dateRoleDevotee: '祈福人',
  dateRolePerson: '當事人',
  dateCalculate: '立即擇日',
  dateCalculating: '擇日中...',
  dateValidationError: '請填妥用事、日期範圍，以及至少一位相關人士的生日。',
  dateMarriageValidationError: '嫁娶擇日請填妥日期範圍，並至少加入兩位相關人士。',
  dateCalcError: '擇日計算失敗，請檢查輸入或稍後再試。',
  dateEdit: '修改條件',
  dateBestTitle: '首選吉日',
  dateTopDatesTitle: '前十吉日',
  dateScrollControls: '吉日捲動控制',
  dateScrollPrev: '向左查看吉日',
  dateScrollNext: '向右查看吉日',
  dateSelectedDetailTitle: '當日詳解',
  dateCalendarSigns: '曆法象意',
  dateLunarDay: '農曆干支',
  dateOfficer: '建除',
  dateTianShen: '天神',
  dateXiu: '二十八宿',
  dateChong: '日沖',
  dateReasonTitle: '取用理由',
  dateWarningTitle: '避忌提示',
  dateNoMajorGood: '此日無明顯加分項，宜作備選。',
  dateNoMajorWarning: '未見重大避忌。',
  datePeopleResultTitle: '相關人士命盤摘要',
  dateAllDatesTitle: '全範圍日課',
  dateWeekday: '星期',
  date: '日期',
  dateGrade: '等級',
  dateYiMatch: '宜項命中',
  dateJiMatch: '忌項命中',
});

Object.assign(translations['zh-CN'], {
  datePageTitle: '择日',
  datePageDesc: '依《钦定协纪辨方书》取法，先定用事与日期范围，再合相关人士生辰，逐日看宜忌、吉神凶煞、建除、黄黑道与日冲。',
  dateEventTitle: '用事',
  dateEventLabel: '所办事项',
  dateEventMarriage: '嫁娶',
  dateEventMoving: '入宅搬迁',
  dateEventOpening: '开市营业',
  dateEventContract: '订盟签约',
  dateEventTravel: '出行',
  dateEventWorship: '祭祀祈福',
  dateEventCustom: '自订事项',
  dateCustomEventLabel: '自订事项',
  dateCustomEventPlaceholder: '例如：开工、见客、安床',
  dateRangeTitle: '日期范围',
  dateStartLabel: '开始日期',
  dateEndLabel: '结束日期',
  dateRangeHint: '请用日期选择器选取公历日期。每次最多计算 366 日。',
  datePeopleTitle: '相关人士',
  datePeopleHint: '至少加入一位相关人士，输入角色与生日即可。',
  dateMarriagePeopleHint: '嫁娶至少需要两位相关人士；可再加入双方父母等角色。',
  dateAddPerson: '加入人士',
  dateRemovePerson: '移除',
  datePerson: '人士',
  dateRoleLabel: '角色',
  dateRolePlaceholder: '例如：新郎、母亲、合作人',
  dateRoleGroom: '新郎',
  dateRoleBride: '新娘',
  dateRoleHomeowner: '户主',
  dateRoleBoss: '老板',
  dateRoleSigner: '签约人',
  dateRoleTraveler: '出行人',
  dateRoleDevotee: '祈福人',
  dateRolePerson: '当事人',
  dateCalculate: '立即择日',
  dateCalculating: '择日中...',
  dateValidationError: '请填妥用事、日期范围，以及至少一位相关人士的生日。',
  dateMarriageValidationError: '嫁娶择日请填妥日期范围，并至少加入两位相关人士。',
  dateCalcError: '择日计算失败，请检查输入或稍后再试。',
  dateEdit: '修改条件',
  dateBestTitle: '首选吉日',
  dateTopDatesTitle: '前十吉日',
  dateScrollControls: '吉日滚动控制',
  dateScrollPrev: '向左查看吉日',
  dateScrollNext: '向右查看吉日',
  dateSelectedDetailTitle: '当日详解',
  dateCalendarSigns: '历法象意',
  dateLunarDay: '农历干支',
  dateOfficer: '建除',
  dateTianShen: '天神',
  dateXiu: '二十八宿',
  dateChong: '日冲',
  dateReasonTitle: '取用理由',
  dateWarningTitle: '避忌提示',
  dateNoMajorGood: '此日无明显加分项，宜作备选。',
  dateNoMajorWarning: '未见重大避忌。',
  datePeopleResultTitle: '相关人士命盘摘要',
  dateAllDatesTitle: '全范围日课',
  dateWeekday: '星期',
  date: '日期',
  dateGrade: '等级',
  dateYiMatch: '宜项命中',
  dateJiMatch: '忌项命中',
});

Object.assign(translations.en, {
  datePageTitle: 'Auspicious Dates',
  datePageDesc: 'Based on the Xieji Bianfang Shu method: choose the event and date range, add related birth details, then rank each day by almanac suitability, stars, day officer, yellow/black path and personal clashes.',
  dateEventTitle: 'Event',
  dateEventLabel: 'Specific event',
  dateEventMarriage: 'Marriage',
  dateEventMoving: 'Moving / home entry',
  dateEventOpening: 'Business opening',
  dateEventContract: 'Agreement / contract',
  dateEventTravel: 'Travel',
  dateEventWorship: 'Worship / blessing',
  dateEventCustom: 'Custom event',
  dateCustomEventLabel: 'Custom event',
  dateCustomEventPlaceholder: 'e.g. work start, client meeting, bed setup',
  dateRangeTitle: 'Date range',
  dateStartLabel: 'Start date',
  dateEndLabel: 'End date',
  dateRangeHint: 'Select Gregorian dates with the date picker. Maximum 366 days per calculation.',
  datePeopleTitle: 'Related people',
  datePeopleHint: 'Add at least one person with role and birthday.',
  dateMarriagePeopleHint: 'Marriage requires at least two related people; you can also add parents from both sides.',
  dateAddPerson: 'Add person',
  dateRemovePerson: 'Remove',
  datePerson: 'Person',
  dateRoleLabel: 'Role',
  dateRolePlaceholder: 'e.g. groom, mother, partner',
  dateRoleGroom: 'Groom',
  dateRoleBride: 'Bride',
  dateRoleHomeowner: 'Homeowner',
  dateRoleBoss: 'Boss',
  dateRoleSigner: 'Signer',
  dateRoleTraveler: 'Traveler',
  dateRoleDevotee: 'Devotee',
  dateRolePerson: 'Related person',
  dateCalculate: 'Find dates',
  dateCalculating: 'Selecting...',
  dateValidationError: 'Please complete the event, date range and at least one related birthday.',
  dateMarriageValidationError: 'For marriage, complete the date range and add at least two related people.',
  dateCalcError: 'Date selection failed. Please check the input or try again later.',
  dateEdit: 'Edit criteria',
  dateBestTitle: 'Best date',
  dateTopDatesTitle: 'Top ten dates',
  dateScrollControls: 'Date scroll controls',
  dateScrollPrev: 'Scroll dates left',
  dateScrollNext: 'Scroll dates right',
  dateSelectedDetailTitle: 'Selected date details',
  dateCalendarSigns: 'Almanac signs',
  dateLunarDay: 'Lunar stems/branches',
  dateOfficer: 'Day officer',
  dateTianShen: 'Heavenly deity',
  dateXiu: 'Lunar mansion',
  dateChong: 'Day clash',
  dateReasonTitle: 'Reasons',
  dateWarningTitle: 'Cautions',
  dateNoMajorGood: 'No major bonus sign; keep as backup.',
  dateNoMajorWarning: 'No major caution found.',
  datePeopleResultTitle: 'Related chart summaries',
  dateAllDatesTitle: 'All dates in range',
  dateWeekday: 'Weekday',
  date: 'Date',
  dateGrade: 'Grade',
  dateYiMatch: 'Yi match',
  dateJiMatch: 'Ji match',
});

Object.assign(translations.ko, {
  datePageTitle: '택일',
  datePageDesc: '행사와 날짜 범위를 정하고 관련 인물의 생일을 넣으면 일진의 길흉, 길신흉살, 건제, 황흑도와 개인 충을 비교해 길일을 고릅니다.',
  dateEventTitle: '행사',
  dateEventLabel: '행사 종류',
  dateEventMarriage: '혼인',
  dateEventMoving: '이사 / 입택',
  dateEventOpening: '개업',
  dateEventContract: '계약',
  dateEventTravel: '출행',
  dateEventWorship: '제사 / 기복',
  dateEventCustom: '직접 입력',
  dateCustomEventLabel: '직접 입력',
  dateCustomEventPlaceholder: '예: 착공, 미팅, 침대 설치',
  dateRangeTitle: '날짜 범위',
  dateStartLabel: '시작일',
  dateEndLabel: '종료일',
  dateRangeHint: '날짜 선택기로 양력 날짜를 선택하세요. 한 번에 최대 366일입니다.',
  datePeopleTitle: '관련 인물',
  datePeopleHint: '최소 한 명의 역할과 생일을 입력하세요.',
  dateMarriagePeopleHint: '혼인은 최소 두 명이 필요하며, 양가 부모도 추가할 수 있습니다.',
  dateAddPerson: '인물 추가',
  dateRemovePerson: '삭제',
  datePerson: '인물',
  dateRoleLabel: '역할',
  dateRolePlaceholder: '예: 신랑, 어머니, 동업자',
  dateRoleGroom: '신랑',
  dateRoleBride: '신부',
  dateRoleHomeowner: '세대주',
  dateRoleBoss: '대표',
  dateRoleSigner: '계약자',
  dateRoleTraveler: '여행자',
  dateRoleDevotee: '기원자',
  dateRolePerson: '당사자',
  dateCalculate: '길일 찾기',
  dateCalculating: '선택 중...',
  dateValidationError: '행사, 날짜 범위, 최소 한 명의 생일을 입력해 주세요.',
  dateMarriageValidationError: '혼인 택일은 날짜 범위와 최소 두 명의 생일이 필요합니다.',
  dateCalcError: '택일 계산에 실패했습니다. 입력을 확인하거나 다시 시도하세요.',
  dateEdit: '조건 수정',
  dateBestTitle: '첫 번째 길일',
  dateTopDatesTitle: '상위 열 날짜',
  dateScrollControls: '길일 스크롤 조작',
  dateScrollPrev: '이전 길일 보기',
  dateScrollNext: '다음 길일 보기',
  dateSelectedDetailTitle: '선택한 날짜 설명',
  dateCalendarSigns: '역법 표시',
  dateLunarDay: '음력 간지',
  dateOfficer: '건제',
  dateTianShen: '천신',
  dateXiu: '이십팔수',
  dateChong: '일충',
  dateReasonTitle: '이유',
  dateWarningTitle: '주의',
  dateNoMajorGood: '큰 가점은 없어 예비일로 보세요.',
  dateNoMajorWarning: '큰 주의점은 보이지 않습니다.',
  datePeopleResultTitle: '관련 인물 명반 요약',
  dateAllDatesTitle: '전체 날짜',
  dateWeekday: '요일',
  date: '날짜',
  dateGrade: '등급',
  dateYiMatch: '좋은 항목',
  dateJiMatch: '피할 항목',
});

Object.assign(translations.ja, {
  datePageTitle: '擇日',
  datePageDesc: '用事と期間を定め、関係者の生年月日を合わせ、宜忌、吉神凶煞、建除、黄黒道、日冲から吉日を選びます。',
  dateEventTitle: '用事',
  dateEventLabel: '行う事',
  dateEventMarriage: '婚礼',
  dateEventMoving: '入宅・引越',
  dateEventOpening: '開業',
  dateEventContract: '契約',
  dateEventTravel: '出行',
  dateEventWorship: '祭祀・祈福',
  dateEventCustom: '自由入力',
  dateCustomEventLabel: '自由入力',
  dateCustomEventPlaceholder: '例：仕事始め、面会、安床',
  dateRangeTitle: '期間',
  dateStartLabel: '開始日',
  dateEndLabel: '終了日',
  dateRangeHint: '日付ピッカーで西暦日付を選択してください。最大366日まで計算します。',
  datePeopleTitle: '関係者',
  datePeopleHint: '少なくとも一人の役割と生年月日を入力してください。',
  dateMarriagePeopleHint: '婚礼は少なくとも二人が必要です。双方の父母も追加できます。',
  dateAddPerson: '人を追加',
  dateRemovePerson: '削除',
  datePerson: '人物',
  dateRoleLabel: '役割',
  dateRolePlaceholder: '例：新郎、母、共同者',
  dateRoleGroom: '新郎',
  dateRoleBride: '新婦',
  dateRoleHomeowner: '世帯主',
  dateRoleBoss: '経営者',
  dateRoleSigner: '契約者',
  dateRoleTraveler: '旅行者',
  dateRoleDevotee: '祈願者',
  dateRolePerson: '当事者',
  dateCalculate: '吉日を選ぶ',
  dateCalculating: '選定中...',
  dateValidationError: '用事、期間、少なくとも一人の生年月日を入力してください。',
  dateMarriageValidationError: '婚礼擇日は期間と少なくとも二人の生年月日が必要です。',
  dateCalcError: '擇日計算に失敗しました。入力を確認してください。',
  dateEdit: '条件を修正',
  dateBestTitle: '第一候補',
  dateTopDatesTitle: '上位十日',
  dateScrollControls: '吉日スクロール操作',
  dateScrollPrev: '左の吉日を見る',
  dateScrollNext: '右の吉日を見る',
  dateSelectedDetailTitle: '当日詳解',
  dateCalendarSigns: '暦法象意',
  dateLunarDay: '旧暦干支',
  dateOfficer: '建除',
  dateTianShen: '天神',
  dateXiu: '二十八宿',
  dateChong: '日冲',
  dateReasonTitle: '取用理由',
  dateWarningTitle: '避忌',
  dateNoMajorGood: '大きな加点はなく、予備日向きです。',
  dateNoMajorWarning: '重大な避忌は見えません。',
  datePeopleResultTitle: '関係者命盤摘要',
  dateAllDatesTitle: '全期間の日課',
  dateWeekday: '曜日',
  date: '日付',
  dateGrade: '等級',
  dateYiMatch: '宜の一致',
  dateJiMatch: '忌の一致',
});

Object.assign(translations.ms, {
  datePageTitle: 'Pilih hari baik',
  datePageDesc: 'Pilih acara dan julat tarikh, tambah hari lahir pihak berkaitan, lalu bandingkan Yi/Ji, bintang baik/buruk, day officer, laluan kuning/hitam dan konflik peribadi.',
  dateEventTitle: 'Acara',
  dateEventLabel: 'Jenis acara',
  dateEventMarriage: 'Perkahwinan',
  dateEventMoving: 'Pindah / masuk rumah',
  dateEventOpening: 'Buka perniagaan',
  dateEventContract: 'Perjanjian / kontrak',
  dateEventTravel: 'Perjalanan',
  dateEventWorship: 'Sembahyang / doa',
  dateEventCustom: 'Acara sendiri',
  dateCustomEventLabel: 'Acara sendiri',
  dateCustomEventPlaceholder: 'cth. mula kerja, jumpa klien, pasang katil',
  dateRangeTitle: 'Julat tarikh',
  dateStartLabel: 'Tarikh mula',
  dateEndLabel: 'Tarikh tamat',
  dateRangeHint: 'Pilih tarikh Gregorian dengan pemilih tarikh. Maksimum 366 hari.',
  datePeopleTitle: 'Pihak berkaitan',
  datePeopleHint: 'Tambah sekurang-kurangnya seorang dengan peranan dan hari lahir.',
  dateMarriagePeopleHint: 'Perkahwinan memerlukan sekurang-kurangnya dua orang; ibu bapa kedua-dua pihak boleh ditambah.',
  dateAddPerson: 'Tambah orang',
  dateRemovePerson: 'Buang',
  datePerson: 'Orang',
  dateRoleLabel: 'Peranan',
  dateRolePlaceholder: 'cth. pengantin lelaki, ibu, rakan kongsi',
  dateRoleGroom: 'Pengantin lelaki',
  dateRoleBride: 'Pengantin perempuan',
  dateRoleHomeowner: 'Ketua rumah',
  dateRoleBoss: 'Pemilik perniagaan',
  dateRoleSigner: 'Penandatangan',
  dateRoleTraveler: 'Pengembara',
  dateRoleDevotee: 'Pemohon doa',
  dateRolePerson: 'Pihak berkaitan',
  dateCalculate: 'Cari hari baik',
  dateCalculating: 'Memilih...',
  dateValidationError: 'Lengkapkan acara, julat tarikh dan sekurang-kurangnya satu hari lahir.',
  dateMarriageValidationError: 'Untuk perkahwinan, lengkapkan julat tarikh dan tambah sekurang-kurangnya dua orang.',
  dateCalcError: 'Kiraan hari gagal. Semak input atau cuba lagi.',
  dateEdit: 'Edit syarat',
  dateBestTitle: 'Hari terbaik',
  dateTopDatesTitle: 'Sepuluh tarikh terbaik',
  dateScrollControls: 'Kawalan skrol tarikh',
  dateScrollPrev: 'Skrol tarikh ke kiri',
  dateScrollNext: 'Skrol tarikh ke kanan',
  dateSelectedDetailTitle: 'Butiran tarikh',
  dateCalendarSigns: 'Tanda almanak',
  dateLunarDay: 'Stem/branch lunar',
  dateOfficer: 'Day officer',
  dateTianShen: 'Dewa langit',
  dateXiu: 'Rumah bulan',
  dateChong: 'Konflik hari',
  dateReasonTitle: 'Sebab',
  dateWarningTitle: 'Amaran',
  dateNoMajorGood: 'Tiada tanda bonus besar; simpan sebagai pilihan sandaran.',
  dateNoMajorWarning: 'Tiada amaran besar ditemui.',
  datePeopleResultTitle: 'Ringkasan carta pihak berkaitan',
  dateAllDatesTitle: 'Semua tarikh',
  dateWeekday: 'Hari minggu',
  date: 'Tarikh',
  dateGrade: 'Gred',
  dateYiMatch: 'Padanan Yi',
  dateJiMatch: 'Padanan Ji',
});

Object.assign(translations.es, {
  datePageTitle: 'Fechas propicias',
  datePageDesc: 'Elige evento y rango, añade nacimientos relacionados y compara Yi/Ji, estrellas favorables/desfavorables, oficial del día, camino amarillo/negro y choques personales.',
  dateEventTitle: 'Evento',
  dateEventLabel: 'Tipo de evento',
  dateEventMarriage: 'Matrimonio',
  dateEventMoving: 'Mudanza / entrar en casa',
  dateEventOpening: 'Apertura de negocio',
  dateEventContract: 'Acuerdo / contrato',
  dateEventTravel: 'Viaje',
  dateEventWorship: 'Ritual / bendición',
  dateEventCustom: 'Evento personalizado',
  dateCustomEventLabel: 'Evento personalizado',
  dateCustomEventPlaceholder: 'ej. empezar obra, reunión, instalar cama',
  dateRangeTitle: 'Rango de fechas',
  dateStartLabel: 'Fecha inicial',
  dateEndLabel: 'Fecha final',
  dateRangeHint: 'Selecciona fechas gregorianas con el selector de fecha. Máximo 366 días por cálculo.',
  datePeopleTitle: 'Personas relacionadas',
  datePeopleHint: 'Añade al menos una persona con rol y fecha de nacimiento.',
  dateMarriagePeopleHint: 'El matrimonio requiere al menos dos personas; también puedes añadir padres de ambos lados.',
  dateAddPerson: 'Añadir persona',
  dateRemovePerson: 'Eliminar',
  datePerson: 'Persona',
  dateRoleLabel: 'Rol',
  dateRolePlaceholder: 'ej. novio, madre, socio',
  dateRoleGroom: 'Novio',
  dateRoleBride: 'Novia',
  dateRoleHomeowner: 'Titular del hogar',
  dateRoleBoss: 'Dueño del negocio',
  dateRoleSigner: 'Firmante',
  dateRoleTraveler: 'Viajero/a',
  dateRoleDevotee: 'Devoto/a',
  dateRolePerson: 'Persona relacionada',
  dateCalculate: 'Buscar fechas',
  dateCalculating: 'Seleccionando...',
  dateValidationError: 'Completa evento, rango y al menos una fecha de nacimiento relacionada.',
  dateMarriageValidationError: 'Para matrimonio, completa el rango y añade al menos dos personas.',
  dateCalcError: 'Falló la selección de fecha. Revisa los datos o intenta de nuevo.',
  dateEdit: 'Editar criterios',
  dateBestTitle: 'Mejor fecha',
  dateTopDatesTitle: 'Diez mejores fechas',
  dateScrollControls: 'Controles de desplazamiento de fechas',
  dateScrollPrev: 'Desplazar fechas a la izquierda',
  dateScrollNext: 'Desplazar fechas a la derecha',
  dateSelectedDetailTitle: 'Detalle de la fecha',
  dateCalendarSigns: 'Signos del almanaque',
  dateLunarDay: 'Tallos/ramas lunares',
  dateOfficer: 'Oficial del día',
  dateTianShen: 'Deidad celeste',
  dateXiu: 'Mansión lunar',
  dateChong: 'Choque del día',
  dateReasonTitle: 'Razones',
  dateWarningTitle: 'Cautelas',
  dateNoMajorGood: 'Sin gran señal favorable; úsala como respaldo.',
  dateNoMajorWarning: 'No se encontró cautela mayor.',
  datePeopleResultTitle: 'Resumen de cartas relacionadas',
  dateAllDatesTitle: 'Todas las fechas',
  dateWeekday: 'Día',
  date: 'Fecha',
  dateGrade: 'Grado',
  dateYiMatch: 'Coincide Yi',
  dateJiMatch: 'Coincide Ji',
});

Object.assign(translations['zh-TW'], {
  namingPageDesc: '輸入命主與父親生辰、姓氏與偏好用字。網站後台自動判定康熙筆劃，先排兩份四柱八字，核五行偏枯，再按三才五格起出十個名字，並由神明回答細審字義、諧音、生肖喜忌與命盤喜用字形。',
  namingBirthTitle: '命主生辰',
  namingFatherBirthTitle: '父親生辰',
  namingNameTitle: '姓氏與偏好',
  namingPreferredText: '偏好文字',
  namingPreferredPlaceholder: '例如：希望名字帶水木之氣、讀音溫雅、可用「霖、梓、謙」等字',
  namingSurnameStrokeHint: '姓氏會影響天格、人格、總格與外格；康熙筆劃由後台自動判定。',
  namingCalculate: '起名起運',
  namingCalculating: '起名起運中...',
  namingProgressTitle: '起名進度',
  namingProgressChart: '正在排命主與父親四柱，核定五行氣勢...',
  namingProgressGrid: '正在推算康熙筆劃、三才五格與八十一數理...',
  namingProgressNames: '正在請神明細審字義、諧音、生肖喜忌與命盤字形...',
  namingProgressFinal: '正在整理十個候選名字與取名理由...',
  namingValidationError: '請填妥命主生辰、父親生辰與姓氏；偏好用字可留空。',
  namingEdit: '重新起名',
  namingOverall: '起名取法',
  namingCandidatesTitle: '十個候選名字',
  namingGeneratedCount: '候選名',
  namingWuxingProfileTitle: '兩份四柱五行',
  namingChildProfile: '命主五行',
  namingFatherProfile: '父親五行',
  namingPillars: '四柱',
  namingDominantElement: '偏重',
  namingMissingElements: '缺少',
  namingNameMeaning: '名字含義',
  namingAuspiciousScore: '吉凶分',
  namingScoreUnit: '分',
  namingCoreGrids: '核心五格',
  namingReason: '取名理由：',
  namingMeaningAnalysis: '字義吉凶',
  namingHomophoneAnalysis: '古今諧音 / 歧義',
  namingZodiacAnalysis: '生肖喜忌',
  namingShapeAnalysis: '命盤喜用字形',
});

Object.assign(translations['zh-CN'], {
  namingPageDesc: '输入命主与父亲生辰、姓氏与偏好用字。网站后台自动判定康熙笔画，先排两份四柱八字，核五行偏枯，再按三才五格起出十个名字，并由神明回答细审字义、谐音、生肖喜忌与命盘喜用字形。',
  namingFatherBirthTitle: '父亲生辰',
  namingNameTitle: '姓氏与偏好',
  namingPreferredText: '偏好文字',
  namingPreferredPlaceholder: '例如：希望名字带水木之气、读音温雅、可用「霖、梓、谦」等字',
  namingSurnameStrokeHint: '姓氏会影响天格、人格、总格与外格；康熙笔画由后台自动判定。',
  namingCalculate: '起名起运',
  namingCalculating: '起名起运中...',
  namingProgressTitle: '起名进度',
  namingProgressChart: '正在排命主与父亲四柱，核定五行气势...',
  namingProgressGrid: '正在推算康熙笔画、三才五格与八十一数理...',
  namingProgressNames: '正在请神明细审字义、谐音、生肖喜忌与命盘字形...',
  namingProgressFinal: '正在整理十个候选名字与取名理由...',
  namingValidationError: '请填妥命主生辰、父亲生辰与姓氏；偏好用字可留空。',
  namingEdit: '重新起名',
  namingOverall: '起名取法',
  namingCandidatesTitle: '十个候选名字',
  namingGeneratedCount: '候选名',
  namingWuxingProfileTitle: '两份四柱五行',
  namingChildProfile: '命主五行',
  namingFatherProfile: '父亲五行',
  namingPillars: '四柱',
  namingDominantElement: '偏重',
  namingMissingElements: '缺少',
  namingNameMeaning: '名字含义',
  namingAuspiciousScore: '吉凶分',
  namingScoreUnit: '分',
  namingCoreGrids: '核心五格',
  namingReason: '取名理由：',
  namingMeaningAnalysis: '字义吉凶',
  namingHomophoneAnalysis: '古今谐音 / 歧义',
  namingZodiacAnalysis: '生肖喜忌',
  namingShapeAnalysis: '命盘喜用字形',
});

Object.assign(translations.en, {
  namingPageDesc: 'Enter the child and father birth details, surname, and preferred characters or imagery. The backend resolves Kangxi strokes, calculates both Bazi charts and five-element balance, then generates ten names by San Cai Wu Ge with divine review.',
  namingFatherBirthTitle: 'Father birth details',
  namingNameTitle: 'Surname and preference',
  namingPreferredText: 'Preferred text',
  namingPreferredPlaceholder: 'e.g. water/wood tone, gentle sound, characters like 霖, 梓, 謙',
  namingSurnameStrokeHint: 'The surname affects Heaven, Personality, Total and Outer grids. Kangxi strokes are resolved automatically in the backend.',
  namingCalculate: 'Generate names',
  namingCalculating: 'Generating...',
  namingProgressTitle: 'Naming progress',
  namingProgressChart: 'Preparing the child and father Bazi charts and five-element balance...',
  namingProgressGrid: 'Calculating Kangxi strokes, San Cai Wu Ge and the 81-number pattern...',
  namingProgressNames: 'Asking for divine review of meaning, sound, zodiac fit and useful radicals...',
  namingProgressFinal: 'Organizing ten candidate names and naming reasons...',
  namingValidationError: 'Please complete child birth details, father birth details and surname. Preferred wording can be left blank.',
  namingEdit: 'Generate again',
  namingOverall: 'Naming method',
  namingCandidatesTitle: 'Ten candidate names',
  namingGeneratedCount: 'names',
  namingWuxingProfileTitle: 'Two Bazi element profiles',
  namingChildProfile: 'Child elements',
  namingFatherProfile: 'Father elements',
  namingPillars: 'Pillars',
  namingDominantElement: 'Dominant',
  namingMissingElements: 'Missing',
  namingNameMeaning: 'Name meaning',
  namingAuspiciousScore: 'Auspicious score',
  namingScoreUnit: 'pts',
  namingCoreGrids: 'Core grids',
  namingReason: 'Reason: ',
  namingMeaningAnalysis: 'Meaning',
  namingHomophoneAnalysis: 'Homophones / ambiguity',
  namingZodiacAnalysis: 'Zodiac fit',
  namingShapeAnalysis: 'Useful radicals',
});

Object.assign(translations.ko, {
  namingFatherBirthTitle: '아버지 출생 정보',
  namingNameTitle: '성과 선호 글자',
  namingPreferredText: '선호 문구',
  namingPreferredPlaceholder: '예: 물/나무 기운, 부드러운 발음, 霖·梓·謙 같은 글자',
  namingSurnameStrokeHint: '성은 천격·인격·총격·외격에 영향을 줍니다. 강희 획수는 후단에서 자동 판정합니다.',
  namingCalculate: '이름 짓기',
  namingCalculating: '이름 짓는 중...',
  namingProgressTitle: '작명 진행',
  namingProgressChart: '명주와 아버지의 사주와 오행 균형을 잡는 중...',
  namingProgressGrid: '강희 획수, 삼재오격과 81수리를 계산하는 중...',
  namingProgressNames: '뜻, 발음, 띠 자형과 보완 자형을 신명 응답으로 살피는 중...',
  namingProgressFinal: '후보 이름 10개와 작명 이유를 정리하는 중...',
  namingValidationError: '명주와 아버지의 출생 정보 및 성을 입력해 주세요. 선호 글자는 비워도 됩니다.',
  namingEdit: '다시 짓기',
  namingOverall: '작명 방식',
  namingCandidatesTitle: '후보 이름 10개',
  namingGeneratedCount: '후보',
  namingWuxingProfileTitle: '두 사주의 오행',
  namingChildProfile: '명주 오행',
  namingFatherProfile: '아버지 오행',
  namingPillars: '사주',
  namingDominantElement: '강한 오행',
  namingMissingElements: '부족한 오행',
  namingNameMeaning: '이름 뜻',
  namingAuspiciousScore: '길흉 점수',
  namingScoreUnit: '점',
  namingCoreGrids: '핵심 오격',
  namingReason: '작명 이유: ',
  namingMeaningAnalysis: '뜻의 길흉',
  namingHomophoneAnalysis: '발음 / 중의성',
  namingZodiacAnalysis: '띠 자형',
  namingShapeAnalysis: '보완 자형',
});

Object.assign(translations.ja, {
  namingFatherBirthTitle: '父親の出生情報',
  namingNameTitle: '姓と希望文字',
  namingPreferredText: '希望文字',
  namingPreferredPlaceholder: '例：水木の気、柔らかな響き、霖・梓・謙など',
  namingSurnameStrokeHint: '姓は天格・人格・総格・外格に影響します。康熙画数は後台で自動判定します。',
  namingCalculate: '命名する',
  namingCalculating: '命名中...',
  namingProgressTitle: '命名の進行',
  namingProgressChart: '本人と父親の四柱、五行バランスを整えています...',
  namingProgressGrid: '康熙画数、三才五格、八十一数理を計算しています...',
  namingProgressNames: '字義、音、生肖喜忌、補益字形を神明回答で確認しています...',
  namingProgressFinal: '候補名十選と命名理由を整理しています...',
  namingValidationError: '本人と父親の出生情報、姓を入力してください。希望文字は空欄でも構いません。',
  namingEdit: 'もう一度命名',
  namingOverall: '命名法',
  namingCandidatesTitle: '候補名十選',
  namingGeneratedCount: '候補',
  namingWuxingProfileTitle: '二つの四柱五行',
  namingChildProfile: '本人五行',
  namingFatherProfile: '父親五行',
  namingPillars: '四柱',
  namingDominantElement: '強い五行',
  namingMissingElements: '不足',
  namingNameMeaning: '名前の意味',
  namingAuspiciousScore: '吉凶スコア',
  namingScoreUnit: '点',
  namingCoreGrids: '主要五格',
  namingReason: '命名理由：',
  namingMeaningAnalysis: '字義吉凶',
  namingHomophoneAnalysis: '音 / 曖昧さ',
  namingZodiacAnalysis: '生肖喜忌',
  namingShapeAnalysis: '命盤補益字形',
});

Object.assign(translations.ms, {
  namingFatherBirthTitle: 'Butiran lahir bapa',
  namingNameTitle: 'Nama keluarga dan pilihan',
  namingPreferredText: 'Teks pilihan',
  namingPreferredPlaceholder: 'cth. unsur air/kayu, bunyi lembut, aksara seperti 霖, 梓, 謙',
  namingSurnameStrokeHint: 'Nama keluarga mempengaruhi grid Langit, Diri, Jumlah dan Luar. Strok Kangxi ditentukan automatik di backend.',
  namingCalculate: 'Jana nama',
  namingCalculating: 'Menjana...',
  namingProgressTitle: 'Kemajuan nama',
  namingProgressChart: 'Menyusun carta Bazi anak dan bapa serta imbangan lima unsur...',
  namingProgressGrid: 'Mengira strok Kangxi, San Cai Wu Ge dan pola 81 nombor...',
  namingProgressNames: 'Meminta semakan ilahi untuk makna, bunyi, zodiak dan radikal berguna...',
  namingProgressFinal: 'Menyusun sepuluh calon nama dan sebab pemilihan...',
  namingValidationError: 'Lengkapkan butiran lahir anak, bapa dan nama keluarga. Pilihan aksara boleh dibiarkan kosong.',
  namingEdit: 'Jana semula',
  namingOverall: 'Kaedah nama',
  namingCandidatesTitle: 'Sepuluh calon nama',
  namingGeneratedCount: 'nama',
  namingWuxingProfileTitle: 'Dua profil unsur Bazi',
  namingChildProfile: 'Unsur anak',
  namingFatherProfile: 'Unsur bapa',
  namingPillars: 'Pillars',
  namingDominantElement: 'Dominan',
  namingMissingElements: 'Kurang',
  namingNameMeaning: 'Maksud nama',
  namingAuspiciousScore: 'Skor baik buruk',
  namingScoreUnit: 'mata',
  namingCoreGrids: 'Grid utama',
  namingReason: 'Sebab: ',
  namingMeaningAnalysis: 'Makna',
  namingHomophoneAnalysis: 'Bunyi / kekaburan',
  namingZodiacAnalysis: 'Padanan zodiak',
  namingShapeAnalysis: 'Radikal berguna',
});

Object.assign(translations.es, {
  namingFatherBirthTitle: 'Nacimiento del padre',
  namingNameTitle: 'Apellido y preferencia',
  namingPreferredText: 'Texto preferido',
  namingPreferredPlaceholder: 'p. ej. energía agua/madera, sonido suave, caracteres como 霖, 梓, 謙',
  namingSurnameStrokeHint: 'El apellido afecta los cuadros Cielo, Personalidad, Total y Exterior. Los trazos Kangxi se resuelven automáticamente en backend.',
  namingCalculate: 'Generar nombres',
  namingCalculating: 'Generando...',
  namingProgressTitle: 'Progreso del nombre',
  namingProgressChart: 'Preparando las cartas Bazi del niño y del padre y el equilibrio de elementos...',
  namingProgressGrid: 'Calculando trazos Kangxi, San Cai Wu Ge y el patrón de 81 números...',
  namingProgressNames: 'Pidiendo revisión divina de significado, sonido, zodiaco y radicales útiles...',
  namingProgressFinal: 'Organizando diez nombres candidatos y sus razones...',
  namingValidationError: 'Completa nacimiento del niño, nacimiento del padre y apellido. La preferencia de caracteres puede quedar vacía.',
  namingEdit: 'Generar otra vez',
  namingOverall: 'Método de nombre',
  namingCandidatesTitle: 'Diez nombres candidatos',
  namingGeneratedCount: 'nombres',
  namingWuxingProfileTitle: 'Dos perfiles Bazi',
  namingChildProfile: 'Elementos del niño',
  namingFatherProfile: 'Elementos del padre',
  namingPillars: 'Pilares',
  namingDominantElement: 'Dominante',
  namingMissingElements: 'Faltante',
  namingNameMeaning: 'Significado del nombre',
  namingAuspiciousScore: 'Puntuación auspiciosa',
  namingScoreUnit: 'pts',
  namingCoreGrids: 'Cuadros clave',
  namingReason: 'Razón: ',
  namingMeaningAnalysis: 'Significado',
  namingHomophoneAnalysis: 'Sonido / ambigüedad',
  namingZodiacAnalysis: 'Ajuste zodiacal',
  namingShapeAnalysis: 'Radicales útiles',
});

Object.assign(translations['zh-TW'], {
  namingPreferenceFit: '偏好文字取用',
  namingNameStory: '名字故事',
  namingCharacterMeaning: '逐字含義',
  namingCharacterFortune: '逐字吉凶',
});

Object.assign(translations['zh-CN'], {
  namingPreferenceFit: '偏好文字取用',
  namingNameStory: '名字故事',
  namingCharacterMeaning: '逐字含义',
  namingCharacterFortune: '逐字吉凶',
});

Object.assign(translations.en, {
  namingPreferenceFit: 'Preference fit',
  namingNameStory: 'Name story',
  namingCharacterMeaning: 'Character meaning',
  namingCharacterFortune: 'Character fortune',
});

Object.assign(translations.ko, {
  namingPreferenceFit: '선호 글자 반영',
  namingNameStory: '이름 이야기',
  namingCharacterMeaning: '글자별 뜻',
  namingCharacterFortune: '글자별 길흉',
});

Object.assign(translations.ja, {
  namingPreferenceFit: '希望文字の反映',
  namingNameStory: '名前の物語',
  namingCharacterMeaning: '一字ごとの意味',
  namingCharacterFortune: '一字ごとの吉凶',
});

Object.assign(translations.ms, {
  namingPreferenceFit: 'Padanan pilihan',
  namingNameStory: 'Cerita nama',
  namingCharacterMeaning: 'Makna setiap aksara',
  namingCharacterFortune: 'Tuah setiap aksara',
});

Object.assign(translations.es, {
  namingPreferenceFit: 'Ajuste a la preferencia',
  namingNameStory: 'Historia del nombre',
  namingCharacterMeaning: 'Significado de cada carácter',
  namingCharacterFortune: 'Fortuna de cada carácter',
});

export function detectPreferredLanguage() {
  const supported = ['zh-TW', 'zh-CN', 'en', 'ko', 'ja', 'ms', 'es'];
  const matchLanguage = (value = '') => {
    const lang = value.toLowerCase();
    if (lang === 'zh-tw' || lang.includes('hant') || lang.includes('hk') || lang.includes('mo')) return 'zh-TW';
    if (lang === 'zh-cn' || lang.includes('hans') || lang.includes('cn') || lang.includes('sg')) return 'zh-CN';
    if (lang.startsWith('ko')) return 'ko';
    if (lang.startsWith('ja')) return 'ja';
    if (lang.startsWith('ms') || lang.startsWith('ms-my')) return 'ms';
    if (lang.startsWith('es')) return 'es';
    if (lang.startsWith('en')) return 'en';
    return null;
  };

  const browserLanguages = Array.from(new Set([
    ...(navigator.languages || []),
    navigator.language,
  ].filter(Boolean)));

  for (const value of browserLanguages) {
    const detected = matchLanguage(value);
    if (detected) return detected;
  }

  try {
    const stored = localStorage.getItem('fc_lang');
    if (supported.includes(stored)) return stored;
  } catch (e) {
    // Ignore storage errors and continue to the regional fallback.
  }

  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (timeZone === 'Asia/Seoul') return 'ko';
    if (timeZone === 'Asia/Tokyo') return 'ja';
    if (timeZone === 'Asia/Kuala_Lumpur') return 'ms';
    if (timeZone === 'Europe/Madrid' || timeZone.startsWith('America/')) return 'es';
    if (timeZone === 'Asia/Hong_Kong' || timeZone === 'Asia/Taipei' || timeZone === 'Asia/Macau') return 'zh-TW';
    if (timeZone === 'Asia/Shanghai') return 'zh-CN';
  } catch (e) {
    // Ignore timezone detection errors.
  }

  return 'zh-TW';
}

export function getLang() {
  // Preserve the visitor's explicit selection across forum/service navigation.
  try {
    const stored = localStorage.getItem('fc_lang');
    if (['zh-TW','zh-CN','en','ko','ja','ms','es'].includes(stored)) return stored;
  } catch (e) { /* Use browser detection when storage is unavailable. */ }
  return detectPreferredLanguage();
}

export function translate(key, lang = getLang()) {
  return (translations[lang] && translations[lang][key]) || translations['zh-TW'][key] || key;
}

export function t(key) {
  return translate(key);
}

export function listenLangChange(callback) {
  window.addEventListener('message', (e) => {
    if (e.data && e.data.type === 'langChange') {
      callback(e.data.lang);
    }
  });
  window.addEventListener('storage', (e) => {
    if (e.key === 'fc_lang') callback(e.newValue);
  });
}

export default translations;
